/*****************************************************************************************************/
/** CUSTOM JAVASCRIPT OPTIONS - THESE SHOULD REALLY BE PPRO.OPTIONS SETTINGS OR CM/CT OPTIONS       **/
/*****************************************************************************************************/

/** This kind of import copies the exported variables into the bundle with these names.
 * To use these libs in other files, import them in that file as well. webpack will de-duplicate.
 */
import { AjaxHelper, SequenceNumber, PProFetch, PProPost } from './ajax'

/** This kind of import copies the file into bundle.js in order */
import '@popperjs/core';
import { Modal, Popover, Tooltip } from 'bootstrap';
import $ from 'jquery';
import 'jquery-migrate';
import 'jquery-ui';
import 'slick-carousel';
import 'datatables.net-bs5';

import { initDashboard, initRecentOrders, initPasswordChange } from './dashboard/index.js';
import { initProfileMaintenance } from './profilemaint/index.js';

import './dayjs.min';
import './includes/main';
import './pprocalendar';

export { $ };


var requireIntQty=true;
var qtyMessage="Please enter a whole number.  This product doesn't accept fractional quantities.";
var po1Message="Please provide a PO number.  If you do not have an actual PO, you may enter your name."
var po2Message=po1Message;
var emailAddressMessage="Please provide an e-mail address for us to send you an order confirmation."
var deliveryDateMessage="Please select a date on which you would like to receive your order."
var pageLoadingMsg="This page is still loading.  Please wait a few moments and try again.";
var outOfStockMessage="We're sorry, but there are only ~avqty of item ~prod in stock.";
var substituteMessage="We recommend substituting item ~substItem.";
var subOutMessage=" Substitutions are available, please click below.";
var calculateGrossSales=false;
var selectQty = false;						// Select quantities upon focus so the user doesn't have to
var highlightPrevQty = false;				// Highlight previous qty after an ENTER (usu. scanner) moves focus to the next product code
var highlightField;
var preventProdDup = true;					// Prevent duplicate product entry in multiple-column entry mode
var entryModeDisableLastMoveOver = true;	// Prevent move over from the last entry field to prevent issues with scanners not sending ENTER
var entryModeLargeQtyFloor = 4;				// Set to a non-zero value N for a confirmation dialog when the quantity is > N digits

/*****************************************************************************************************/
/** DO NOT CUSTOMIZE BELOW THIS LINE - ADD JAVASCRIPT TO SYSTEM PAGE OR INCLUDE NEW JAVASCRIPT FILE **/
/*****************************************************************************************************/

export const PProAjax = new AjaxHelper();
const PProAjaxSequence = new SequenceNumber('ajaxSequenceNext');
/**
 * STARTUP. Entry point for everything that has to run after page is fully loaded
 */
window.addEventListener("DOMContentLoaded", () => {
	PProAjax.initAfterDomLoaded();
	// Bug preventer, no channges outside this file!
	Object.seal(PProAjax);
	Object.seal(PProAjaxSequence);

	// React components, loaded into the ID's specified here
	const dashboardElement = document.getElementById("react-dashboard");
	if (dashboardElement) {
		initDashboard(dashboardElement);
	}
	const recentOrdersElement = document.getElementById("react-recent-orders");
	if (recentOrdersElement) {
		initRecentOrders(recentOrdersElement);
	}
	const passwordChangeElement = document.getElementById("react-password-change");
	if (passwordChangeElement) {
		initPasswordChange(passwordChangeElement);
	}
	const profMaintElement = document.getElementById("react-profile-maintenance");
	if (profMaintElement) {
		initProfileMaintenance(profMaintElement);
	}

	// Initialize everything.  
	// Some initializations will be skipped if meta tags do not exist in the HTML
	SystemPage.initialize();
	PProLoading.initialize();
	PProReports.initialize();
	SystemPage.customOrderEntryOnLoad();
	OrderAddOn.initialize();
	PProCalendar.initialize();
	PProDldt.initialize();
	PProContactUs.initialize();
	PriceList.initialize();
	ContactMaint.initialize();
	OpenInvoice.initialize();
	PProProfile.initialize();
	PProCart.initialize();
})

/************* Utilities **************/
/**
 * Misc. utilities
 */
export const PProUtil = {
	/**
	 * @param {any} testObject
	 * @returns {bool} true only if testObject is an empty object, e.g. `{}`. Othewise returns false.
	 */
	IsEmptyObject: (testObject) => {
		return (
			testObject &&
			Object.getPrototypeOf(testObject) === Object.prototype &&
			Object.keys(testObject).length === 0
		);
	},
	/**
	 * @param {string} str containing HTML
	 * @returns {any} Node object
	 */
	nodeFromHTML: (str) => {
	    var template = document.createElement('template');
	    template.innerHTML = "<div>" + str.trim(); + "</div>";
	    return template.content.firstElementChild;
	},
	/**
	 * @param {string} funcToCheck
	 */
	CheckJsOnLoad: (funcToCheck) => {
		const result = document.querySelector(`meta[onload=${funcToCheck.replace('.', '\\.')}]`);
		return result !== null;
	},
	/**
	 * @param {string} prodnum to pad with leading 0's
	 */
	addZerosToProductNum: (prodnum) => {
		var num = Number(prodnum).toString();
		if (num !== "NaN") {
			// Replace with padStart when dropping IE support.
			while (num.length < 5) {
				num = "0" + num;
			}
			return num;
		} else {
			return prodnum;
		}
	},
	/**
	 * @param {element} parent element to remove all classes from
	 */	
	removeAttributesAndClasses: (element) => {
		if (element.nodeType === 1) { // Check if it's an element node
			// Remove all attributes and classes from the element
		    element.removeAttribute('class');
		    const attributes = element.attributes;
		    for (let i = attributes.length - 1; i >= 0; i--) {
		    	element.removeAttribute(attributes[i].name);
			}
		}
		// Recursively remove attributes and classes from children
		const children = element.childNodes;
		for (let i = 0; i < children.length; i++) {
		  PProUtil.removeAttributesAndClasses(children[i]);
		}
    }
}
/**
 * Loading helpers
 */
export const PProLoading = {
	initialize: () => {
		window.addEventListener("pageshow", (event) => {
			if (event.persisted) PProLoading.hide();
		});
	},
	show: () => {
		if (document.readyState !== "loading") {
			document.querySelector(".loading")?.classList.remove("hidden");
		}
	},
	hide: () => {
		if (document.readyState !== "loading") {
			document.querySelector(".loading")?.classList.add("hidden");
		}
	},
	showSearchSkeleton: () => {
		document.querySelector(".search-loading-elem")?.classList.add("search-loading");
	},
	hideSearchSkeleton: () => {
		document.querySelector(".search-loading-elem")?.classList.remove("search-loading");
	}
};

class DialogButton {
	/**
	 * @param {string} label
	 * @param {Function?} onClickFunc
	 */
	constructor(label, onClickFunc) {
		this.label = label;
		this.onClickFunc = onClickFunc;
		this.onClickEventHandler;
	}
}
/**
 * Dialog helper. 
 */
class DialogHelper {
	constructor() {
		this.pproModalElem = document.querySelector("#ppro-common-modal");
		this.pproModal_title = this.pproModalElem.querySelector(".modal__title");
		this.pproModal_message = this.pproModalElem.querySelector(".ppro-modal-message");
		this.pproModal_primaryButton = this.pproModalElem.querySelector(".btn-primary");
		this.pproModal_secondaryButton = this.pproModalElem.querySelector(".btn-secondary");
		this.activeButtonList = [];
		this.activeCloseHandlers = [];

		this.pproModal = new Modal(this.pproModalElem);
		this.pproModalElem.addEventListener('hidden.bs.modal', () => { PProDialog._onHideModal() });
		this.pproModal.hide();
	}
	alert(message, qtyField) {
		this.showModal("Alert", message).addEventListener("hidden.bs.modal", () => {
			if (qtyField) {
				setTimeout(function() { 
					qtyField.focus(); 
					qtyField.select();
				}, 100); // need delay for FireFox
			}
		});
	}
	/**
	 * @param {string} title
	 * @param {string} message
	 * @param {DialogButton?} primaryButton Defaults to "OK" and closes dialog
	 * @param {DialogButton?} secondaryButton Defaults to being hidden
	 * @returns modal wrapper element which you can add events to
	 */
	showModal(title, message, primaryButton, secondaryButton, fullscreen) {
		this.pproModal_title.innerHTML = title;
		this.pproModal_message.innerHTML = message;

		if (fullscreen) {
			const dlg = this.pproModalElem.querySelector("#ppro-common-modal .modal-dialog");
			dlg.classList.add("modal-lg");
			dlg.style.width = "100%";
		}

		if (!primaryButton) {
			this.pproModal_primaryButton.classList.add("hidden");
		} else {
			this.pproModal_primaryButton.classList.remove("hidden");
			this.pproModal_primaryButton.innerHTML = primaryButton.label;
			primaryButton.onClickEventHandler = this.pproModal_primaryButton.addEventListener('click', primaryButton.onClickFunc);
		}

		if (!secondaryButton) {
			this.pproModal_secondaryButton.classList.add("hidden");
		} else {
			this.pproModal_secondaryButton.classList.remove("hidden");
			this.pproModal_secondaryButton.innerHTML = secondaryButton.label;
			secondaryButton.onClickEventHandler = this.pproModal_secondaryButton.addEventListener('click', secondaryButton.onClickFunc);
		}
		if (primaryButton && !secondaryButton) this.activeButtonList.push(primaryButton);
		if (primaryButton && secondaryButton) this.activeButtonList.push(primaryButton, secondaryButton);
		this.pproModal.show();
		return this.pproModalElem;
	}
	hideModal() {
		this.pproModal.hide();
	}
	modalOnClose(func) {
		this.activeCloseHandlers.push(this.pproModalElem.addEventListener('hide.bs.modal', func));
	}
	_onHideModal() {
		// Clear content
		this.pproModal_title.innerHTML = "";
		this.pproModal_message.innerHTML = "";
		this.pproModal_primaryButton.innerHTML = "";
		this.pproModal_secondaryButton.innerHTML = "";

		// remove fullscreen styles
		const dlg = this.pproModalElem.querySelector("#ppro-common-modal .modal-dialog");
		dlg.classList.remove("modal-lg");
		dlg.style.width = "";

		// Remove click handlers, clear list
		for (let btn in this.activeButtonList) {
			this.pproModal_primaryButton.removeEventListener('click', btn.onClickEventHandler);
			this.pproModal_secondaryButton.removeEventListener('click', btn.onClickEventHandler);
		}
		this.activeButtonList = [];

		// Remove close handlers, clear list
		for (let handler in this.activeCloseHandlers) {
			this.pproModalElem.removeEventListener('hide.bs.modal', handler);
		}
		this.activeCloseHandlers = [];
	}
	
	fancyConfirm(that, element, title, message, buttons, right) {
		if (element && element.attributes["aria-describedby"]) {
			return; // Popup already present 
		}
	
		if (PProWeglot.isEnabled() && !skipTranslate) {
			PProWeglot.translateStrings(title, message)
				.then((result) => {
					fancyConfirm.call(this, that, element, result[0] ? result[0] : title, result[1] ? result[1]: message, buttons, right);
				}).catch((err) => {
					console.error("Weglot failed to translate. ", err);
					fancyConfirm.call(this, that, element, title, message, buttons, right);
				});
			return;
		}
	
		let popover = new Popover(element, {
			title: title,
			content: '<div>' + message + '</div>',
			placement: right ? 'right' : 'auto',
			trigger: 'manual',
			html: true
		});
		element.addEventListener('shown.bs.popover', (e) => {		
			const popID = e.target.attributes["aria-describedby"].value;
			const pbody = document.querySelector("#" + popID + " div.popover-body");
			document.querySelector("#" + popID).classList.add("fancyConfirm");
			// remove buttons incase same popup is used again
			pbody.querySelectorAll('a').forEach((link) => link.remove()); 
			for (const [text, f] of Object.entries(buttons)) {
				var buttonEl = document.createElement("a");
				buttonEl.onclick = (event) => { 
					popover.dispose();
					// On close, remove popover attribute
					e.target.removeAttribute("aria-describedby");
					return f(event); 
				};
				var buttonTextEl = document.createElement("span");
				buttonTextEl.className = "button text-center button--outline button--bg-white mx-2 mt-2";
				buttonTextEl.innerText = text;
				buttonEl.appendChild(buttonTextEl);
				pbody.appendChild(buttonEl);
			}
		});
		popover.show(); 
	}
}
export const PProDialog = new DialogHelper();
Object.seal(PProDialog);

/************ PER PAGE Functions **************/

/************ ORDER HISTORY **************/
export const OrderHistory = {
	submitAjax: (event) => {
		PProLoading.show();
		const url = UIservletForm.getAttribute("action");
		const formData = new FormData(UIservletForm);
		let fields = [];
		for (let key of formData.keys()) {
			fields.push(key);
		}
		PProAjax
			.submit(url, "search_results", fields)
			.finally(() => { PProLoading.hide(); })
		event.preventDefault();
		return false;
	},
	performVoidAction: (element, order) => {
		PProDialog.fancyConfirm(window, element, 'Cancel Order ' + order, 'Are you sure that you want to cancel order ' + order + '?', {
			[PProWeglot.YES()]: () => {
				gaVoidOrder(); // log the attempt
				PProFetch("command=VoidOrderHandler.ordervoid&sono=" + order, {
					dataType: "json",
					cache: "no-cache",
					xhrFields: {
						withCredentials: true
					}
				}).then((response) => {
					return response.json();
				}).then((data) => {
					var success = data.success;
					PProDialog.showModal("Cancel Order " + (data.success ? " Successful" : "Failed"), data.message, {
						label: "OK",
						onClickFunc: () => {
							if (success) {
								// Remove row from order list table
								var orderList = document.querySelector("#orderList");
								if (orderList) {
									var table  = orderList.dataTable.tables( { api: true } );
									table.row("#" + order).remove().draw();
								} else {
									// reload page, for calendar page and others
									window.location.reload();
								}
							}
						}
					});
				}).catch((e) => {
					console.error(e);
					PProDialog.showModal("Cancel Order Failed", "Something went wrong.  Please try again.");
				});
			},
			[PProWeglot.NO()]: () => { /* do nothing */ }
		});
	}
}

/*********** CONSTANTS*****************/
var PM_COMMODITY_ONCHANGE_PARM= '__COMM_SEL_ONCHG__';
var PM_BRAND_ONCHANGE_PARM= '__BRAND_SEL_ONCHG__';
var PM_CLASS_ONCHANGE_PARM= '__CLASS_SEL_ONCHG__';

export function getDefaultPONO(sPONO, sRTYPE) {
	if (useRollup)
		sPONO = getDeCARollupNumber(sPONO, sRTYPE);
	return sPONO;
}

/*************************************************
 * Initialize here, but may be reset by E-Commerce 
 * application;
 ***************************************************/
export let requireEmailAddress=false;

/***************************************************
* processing=true disables any form submits.  It's
* used to prevent users from breaking their pipe by
* submitting another request before the first one
* is done processing.  This is also important when
* using incremental page loading.  The onload event
* needs to set processing=false.
*
* As of 12/2005 this is only used at Indy Fruit because
* support paging and incremental page loading.
****************************************************/
var processing = true;
/**************************************************/

var cancelsubmit=false;      // TableCatalog outputFormResults() uses this
var kerchunkEnabled = false; // StandardTableCatalog outputFormResults() 
							 // flips this to true for the catalog page
var arrOldValues;

function verifyFormat(field){
	var retVal = false;
	var value = field.value;
	
	//Format: MMDDYYYY
	if (value.length === 8 && !isNaN(value)){
		retVal = true;
	}
	
	//Format: MM/DD/YYYY
	if (value.length === 10){
		var valArr = value.split("/");
		if (valArr.length === 3 && valArr[2].length === 4){
			retVal = true;
		}
	}
	
	//blank dates are valid
	if (value.length === 0){
		retVal = true;
	}
	
	return retVal;
}

function getDeCARollupNumber(sPONO, sRTYPE) {
	// W = Weekly
	// B = Bi-Weekly
	if (sRTYPE == "W" || sRTYPE == "B") {
		try {
			document.getElementById('PONOONE').disabled = true;
			// Calculate Roll-Up number
			const calDate = new Date(document.getElementById('DLDTVAL').value);
			let iDeliveryMonth = calDate.getMonth() + 1; // convert from 0 based to 1 based month index
			let iAddToYear = 0;
			if (iDeliveryMonth == 10 || iDeliveryMonth == 11 || iDeliveryMonth == 12) {
				iAddToYear = 1; // adjust for new fiscal year
			}
			// Adjust for October 1st being start of Fiscal Year for DECA
			if (iDeliveryMonth <= 9) {
				iDeliveryMonth += 3;
			} else {
				iDeliveryMonth -= 9;
			}
			// Get last digit of year and append "0"
			const sFirst = ((calDate.getFullYear() + iAddToYear).toString().substring(3, 4)) + "0";
			// Calculate 'week' number based on October 1st = 1
			let iLast = ((iDeliveryMonth - 1) << 2) + ((calDate.getDate() >> 3) + 1);
			if (sRTYPE == "B") {
				iLast = iLast + (iLast % 2)
			}
			sPONO = sFirst + (iLast.toString().length == 1 ? "0" : "") + iLast;
		} catch (ex) { }
	}
	return sPONO;
}

function getFractionMessage(fraction) {
	return "You may only order in fractions of " + fraction + ".  Please modify your order quantity.";
}

function entrySearchSubmit() {
	var searchtext = document.UISERVLET_ENTRY["text"].value;

	searchtext = PProUtil.addZerosToProductNum(searchtext);
	if (!PProProfile.preCheckCatalogSearch(searchtext)) return false;

	if (searchtext != "") {	
	    gaSearchEvent(searchtext);
		var url="command=productSearchSubmit&ENTRY=Y&DESC=" + searchtext + "&page=" + document.UISERVLET_ENTRY["POPUP"].value;
		openWindowCentered(url, 'Search', true);
		return true;
	}
	return false;
}

function profilepage(page) {
	if (processing == true) {
		PProDialog.alert(pageLoadingMsg);
		return;
	}
	var searchtext = document.getElementById("SearchText")?.value;
	if(!searchtext) searchtext="nothing";
	document.UIservletForm["parm"].value=searchtext;
	document.UIservletForm["nextCommand"].value="catalogpage";
	document.UIservletForm["name"].value="profile";
	document.UIservletForm["PAGE"].value=page;
	PProLoading.show();
	document.UIservletForm.submit();
}
function nextprofilepage(increment) {
	if (document.UIservletForm["PAGE"].value=="") document.UIservletForm["PAGE"].value="0";
	var thePage = Number(document.UIservletForm["PAGE"].value);
	thePage = thePage + increment;
	profilepage(thePage);

}

function processEntryKeys(event, theField, prevFieldName) {
	if (theField.name=="ENTRYQTY") {
		if (getEventCode(event) == 13) {
			submitEntryForm();
			return false;
		}
		processKeys(event, prevFieldName, theField);		
	} else if (theField.name=="ENTRYPDNO") {
		processKeys(event, prevFieldName, theField);
	}
}

function submitEntryForm() {
	if (!document.getElementById('entrysheet') && trim(document.UISERVLET_ENTRY.ENTRYPDNO.value) == "") {
		PProDialog.alert("Please enter a valid product number.");	
		return false;
	}
	
	if (!cancelDuplicate()) {
		document.UISERVLET_ENTRY["Submit"].disabled = true; // prevents double click on submit
		document.UISERVLET_ENTRY.submit();
	}
}
function cancelDuplicate(){
	try { 
		cartItems = document.UIservletForm["cartItemList"].value;
		if (document.getElementById('entrysheet')) {
			// Using multiple items entry sheet
			for (i1 = 0;;i1++) {
				var pdno = document.getElementById('ENTRYPDNO_' + i1); 
				if (pdno) {
					pdno = zeroPad(pdno.value, 5);
					if (cartItems.indexOf(pdno) >= 0) {
						confirm("You are trying to add a duplicate of item " + pdno + " to the order, which is not allowed.");
						return true;
					}
				} else break;
			}
		} else {
			pdno = zeroPad(document.UISERVLET_ENTRY.ENTRYPDNO.value, 5);
			if (cartItems.indexOf(pdno) >= 0) {
				confirm("You are trying to add a duplicate of item " + pdno + " to the order, which is not allowed.");
				return true;
			}
		}
	} catch (ex) { }		
	return false;
}

export function processKeys(event, prevFieldName, currentField) {
	if (prevFieldName === undefined) prevFieldName = "U&EFU&FUEU";
	var code = getEventCode(event);

	// Focus to previous input field
	if (code == 37 || code == 38 ) {	// 37 = left arrow, 38 = up arrow
		// Prevent duplicate product numbers
		if (preventProdDup && currentField && currentField.name.substr(0, 9) == "ENTRYPDNO") {
			if (checkProdDuplicates(currentField)) return false;	// Duplicate found, exit before moving fields
		}
		
		var prevField;
		if (prevFieldName) {
			if (currentField && currentField.form) {
				if (currentField.form[prevFieldName]) {
					prevField = currentField.form[prevFieldName];
					if (selectQty && prevFieldName.substr(0, 8) == "ENTRYQTY") {
						setTimeout(function() {currentField.form[prevFieldName].select();}, 0);
					} else {
						currentField.form[prevFieldName].focus();
					}
				}
			} else {
				if(document.UIservletForm[prevFieldName]) {
					prevField = document.UIservletForm[prevFieldName];
					document.UIservletForm[prevFieldName].focus();
					if (selectQty) setTimeout(function() {document.UIservletForm[prevFieldName].select()}, 0);
				}
			}
		}
		
		// Check for large quantities
		if (currentField && currentField.name.substr(0, 8) == "ENTRYQTY") entryModeLargeQtyCheck(event, currentField, prevField);
		
		// Unhighlight quantity fields
		if (highlightPrevQty && currentField && prevFieldName) unhighlightQuantities(currentField.form, prevFieldName);

	// Focus to next input field
	} else if (code == 40 || code == 13 || code == 39 || code == 17) { // 40 = down arrow, 13 = enter, 39 = right arrow, 17 = treat like tab
		// Unhighlight quantity fields
		if (highlightPrevQty && currentField) unhighlightQuantities(currentField.form);
		
		// Highlight the previous quantity field after ENTER key is used to move to the next product number field
		if (highlightPrevQty && prevFieldName && currentField && code == 13) {
			if (currentField.name.substr(0, 8) == "ENTRYQTY") {
				currentField.className = "highlight";
				highlightField = currentField;
			}
		}
		
		if (currentField) {
			if (currentField.name.substr(0, 9) == "ENTRYPDNO") {
				// Prevent duplicate product numbers
				if (preventProdDup && checkProdDuplicates(currentField)) {
					return false;	// Duplicate found, exit before moving fields
				}
			} else if (currentField.name.substr(0, 8) == "ENTRYQTY") {
				// Check for large quantities
				entryModeLargeQtyCheck(event, currentField); 
			}
		}
		
		// Check if this is the last field in entry mode
		if (entryModeDisableLastMoveOver && currentField) {
			if (checkEntryModeLastField(event, currentField)) return false;
		}
		
		// Focus to next input field
		if (event.srcElement) doTabNext(event.srcElement); // IE
		else doTabNext(event.target);
		if (code == 13) {
			// Do not let enter key propagate to browser
			cancelEvent(event);
		}		
	} else if (code == 9) { // 9 = tab
		if (highlightPrevQty) unhighlightQuantities(currentField.form);
		
		// Check for large quantities
		if (currentField && currentField.name.substr(0, 8) == "ENTRYQTY") entryModeLargeQtyCheck(event, currentField);
	}
	
	return false;
}

function cancelEvent(event) {
	if (typeof event.preventDefault != "undefined") {
		event.preventDefault();
    } 
	if (typeof event.stopPropagation != "undefined") {
    	event.stopPropagation();
    }
    try { 
    	event.cancelBubble = true; 
    	event.returnValue  = false; 
    } catch (e) { }
}

/*
 * This function unhighlights all the quantity input fields if in multiple column entry mode
 */
function unhighlightQuantities(form, prevFieldName) {
	for (var i = 0; i < form.length; i++) {
		if (form.elements[i].name.substr(0, 8) == "ENTRYQTY") {
			if (!prevFieldName || form[prevFieldName] != highlightField) {
				form.elements[i].className = "";
			}
		}
	}
	highlightField = null;
}

/*
 * A listener function to select the contents of an input field
 */
function selectInputListener(event) {
	var currentField = event.target || event.srcElement;
	setTimeout(function() {currentField.select();}, 0);
	return true;
}

/*
 * A listener function for a TAB key event to check product duplicates
 */ 
function checkProdDupListener(event) {
	var code = getEventCode(event);
	if (code == 9) {
		var currentField = event.target || event.srcElement;
		if (checkProdDuplicates(currentField, event)) {
			cancelEvent(event);
			return false;
		}
	}
}

/*
 * A function to check for product duplicates if in multiple column entry mode
 */
function checkProdDuplicates(currentField, event) {

	if (trim(currentField.value) == "") return false;

	// Check the product number entry input fields
	var form = currentField.form;
	for (var i = 0; i < form.length; i++) {
		if (form.elements[i].name.substr(0, 9) == "ENTRYPDNO") {
			if (form.elements[i].name != currentField.name) {
				if (trim(form.elements[i].value) == "") break;
				if (form.elements[i].value == currentField.value) {
					PProDialog.alert("Product " + currentField.value + " was already entered.");
					currentField.value = "";
					return true;
				}
			}
		}
	}

	// Check the items already added to the order. If there are any,
	// they will be contained in UIservletForm in a hidden input
	// field with name="cartItemList" as a comma separated list
	form = document.UIservletForm;
	if (form) {
		var cartItemList = form.elements["cartItemList"];
		if (cartItemList) {
			var items = cartItemList.value.split(",");
			for (var i = 0; i < items.length; i++) {
				if (!items[i] || trim(items[i]) == "") break; // There may be an extraneous comma on the end
				var val = currentField.value;
				while (val.length < 5) val = "0" + val;
				if (items[i] == val) {
					PProDialog.alert("Product " + items[i] + " has already been added to the order.");
					currentField.value = "";
					return true;
				}
			}
		}
	}

	return false;
}

/*
 * A listener for the TAB event to prevent moving off the last quantity entry field.
 */
function entryModeLastFieldListener(event) {
	var eventCode = getEventCode(event);
	if (entryModeDisableLastMoveOver && eventCode == 9) {
		var currentField = event.target || event.srcElement;
		if (checkEntryModeLastField(event, currentField)) {
			cancelEvent(event);
		}
	}
}

/*
 * If entryModeDisableLastMoveOver is true, disable the TAB, enter, or arrow key over from the last quantity field.
 * This will prevent scanner issues, i.e., if scanner is not sending an ENTER as the last
 * character, the app won't be able to put an item number in a shopping cart quantity field.
 */
function checkEntryModeLastField(event, currentField) {
	if (currentField && currentField.form) {
		// Check to see if this is the last ENTRYQTY field
		if (currentField.name.substr(0, 8) == "ENTRYQTY") {
			var qtyIndex = currentField.name.substring(9);
			if (Number(qtyIndex)) {
				qtyIndex = Number(qtyIndex);
				qtyIndex++;
				var nextQtyField = "ENTRYQTY_" + qtyIndex;
				if (!currentField.form[nextQtyField]) {
					currentField.blur();
					setTimeout(function() {
						PProDialog.alert("You have reached the last input field. Press \"Add to Order\" before adding more items.");},
						0
					);
					return true;
				}
			}
		}
	}	
}

/*
 * Checks the size of the quantity if entryModeLargeQtyFloor is set to a value greater
 * than 0. If so, and the size is greater than the floor, pops up a jQuery modal
 * dialog for confirmation of the number.  The user can allow the quantity, or hit
 * No and the quantity will reset to 1.  This helps prevent accidental scans of item
 * numbers into the quantity fields.
 */
function entryModeLargeQtyCheck(event, qtyField, focusField) {
	if (qtyField && qtyField.name.substr(0, 8) == "ENTRYQTY"
			&& entryModeLargeQtyFloor && entryModeLargeQtyFloor > 0) {
				
		var qty = trim(qtyField.value);
		var numericQty = Number(qty);
		if (!isNaN(numericQty) && numericQty > 0 && qty.length > entryModeLargeQtyFloor) {
			// var qtyConfirmation = document.querySelector("#qty_confirmation").cloneNode(true);
			// qtyConfirmation.removeClass("hidden");
			cancelEvent();
			
			PProDialog.modalOnClose(() => {
				setTimeout(() => {
					if (focusField) {
						focusField.focus();
					} else {
						if (event.srcElement) doTabNext(event.srcElement);
						else doTabNext(event.target);
					}
				}, 0);
			});
			PProDialog.showModal(
				"Large quantity entered",
				"You have entered a very large quantity. Is this quantity correct?<br>Pressing \"No\" will reset the quantity to 1.",
				new DialogButton("Yes, qty is correct"),
				new DialogButton("No, reset qty to 1", () => {
					qtyField.value = "1";
				})
			)
		}
	}
	
	return true;
}

export function processCartKeys(event, currentField) {
	var code = getEventCode(event);
	if (code == 13 || code == 40 || code == 38) {
		var fieldName = String(currentField.name);
		var underscorePosition = fieldName.lastIndexOf("_", fieldName.length);
		var fieldTypeName = fieldName.substring(0, underscorePosition);		 
		var index = fieldName.substr(underscorePosition + 1);		 
		if (code == 38) {
			if (fieldTypeName == "COMMENT"){
				PProProfile.setFormFocus("QNTY_" + index);
			} else if(index > 0){
				index = Number(index) - 1;
				if (PProProfile.setFormFocus("COMMENT_" + index) == false){
					PProProfile.setFormFocus("QNTY_" + index);
				}
			}
		} else if (code == 13 || code == 40) {	
			if (fieldTypeName == "COMMENT") {
				index = Number(index) + 1;
				PProProfile.setFormFocus("QNTY_" + index);
			} else {
				if (PProProfile.setFormFocus("COMMENT_" + index) == false) {	
					index = Number(index) + 1;
					PProProfile.setFormFocus("QNTY_" + index);
				}
			}
		}
		cancelEvent(event);
	}
	return false;
}

export function getEventCode(event) {
	var code = 0;
	if (!event) var event = window.event
	if (event.which) {
		code = event.which;
	} else if (event.keyCode) {
		code = event.keyCode;
	} 
	return code;
}

function doTabNext(el) {
	var f = el.form;
	var els = f.elements;
	var x, nextEl;
	for (var i=0, len=els.length; i<len; i++) {
		x = els[i];
		if (el == x) {
			for (var j = i + 1; j < len; j++) {
				nextEl = els[j];
				if ((nextEl.type == "text") && nextEl.focus 
						&& nextEl.name.indexOf("invqty_") == -1 && nextEl.name != "textdup") {
					nextEl.focus();
					if (selectQty) setTimeout(function() {nextEl.select()}, 0);
					break;
				}
			}
			nextEl.focus(); // If only one product, remove focus from current field so qty can be validated
			break;
		}
	}
}

/***

function remapCode(code){
	newCode=0;
	switch(code){
		case 40:
			newCode=9;
			break;
	}
	return newCode;	

}
**/

export function taLimit(event) {
	var taObj = event.target || event.srcElement;
	if (taObj.value.length == taObj.maxLength) return false;
}

export function taCount(event, visCnt) { 
	var taObj = event.target || event.srcElement;
	var maxlength;
	 if (!('maxLength' in taObj)) { /* IE 7 and older - Needed for BirchStreet */
	 	maxlength = document.getElementById(visCnt.id + 'Max').value;
	 } else maxlength = taObj.maxLength;
	if (taObj.value.length > maxlength) {
		taObj.value = taObj.value.substring(0, maxlength);
	}
	if (visCnt) {
		visCnt.innerHTML = (maxlength * 1) - taObj.value.length;
	}
}

export function taCount2(visCnt, txtFieldName) { 
	var taObj = document.UIservletForm[txtFieldName];
	if (taObj.value.length > taObj.getAttribute('maxlength') * 1) {
		taObj.value = taObj.value.substring(0, taObj.getAttribute('maxlength') * 1);
	}
	if (visCnt) {
		visCnt.innerHTML = (taObj.getAttribute('maxlength') * 1) - taObj.value.length;
	}
}

export function cancelPrompt(bMultiple) {
	var msg;
	if (bMultiple && bMultiple == true) {
		msg = "This will cancel your order for " + document.getElementById('DLDTVAL').value + ".\n\nYou may:\n   1. Click OK to confirm the action and cancel this order, or\n   2. Click the Cancel button to return to your order.";
		// Do things the old way for multiple orders.  
		return confirm(msg);
	} else {
		msg = "<b>This action will empty your shopping cart!</b><br> <br>You may:<br>   1. Click Empty Cart to confirm that you would like to abort your order progress, or<br>   2. Click the Continue Shopping button to return to your order.";
	}

	var btn1 = "Continue Shopping";
	var btn2 = "Empty Cart";
	var title = "Confirm";
	if (PProWeglot.isEnabled()) {
		PProWeglot.translateStrings(title, msg, btn1, btn2)
			.then((result) => {
				cancelPromptDialog(result[0], result[1], result[2], result[3]);
			})
	} else {
		cancelPromptDialog(title, msg, btn1, btn2);
	}
	return false;
}

function cancelPromptDialog(title, msg, btn1, btn2) {
	PProDialog.showModal(
		title,
		msg,
		new DialogButton(btn1),
		new DialogButton(btn2, () => {
			PProLoading.show();
			PProPost("cartformsubmit", '<input type="hidden" name="function_clear" value="YES">');
		})
	);
}

// Create jquery ui dialog that is 80% the width and height of the screen.  
// Scroll parameter not used.  It is hardcoded in the Java code.  For legacy reasons we can't easily get rid of it.
export function openWindowCentered(url, title, showPrintButton) {
	const pbutton = (showPrintButton ? "<div class='order__buttons d-flex flex-wrap justify-content-end noprint'><span class='print'><input type='button' id='btnprint' value='Print' class='print__button my-1 button button--outline' onclick='Ecom2.printPopup();'></span></div>" : "");
	if (url.indexOf("png") >= 0) {
		PProDialog.showModal(
			title,
			"<img src=\"" + url + "\">" + pbutton,
			null,
			null,
			true
		)
	} else {
		PProLoading.show();
		if (document.getElementById('centered_dialog') == null) {
			const dlgdiv = document.createElement('div');
			dlgdiv.id = 'centered_dialog';
			dlgdiv.classList.add('hidden');
			document.body.appendChild(dlgdiv);
		} else {
			document.getElementById('centered_dialog').innerHTML = "";
		}
		PProAjax.submit(new URL(url, window.location.origin).toString(), 'centered_dialog').finally(() => { 
			PProLoading.hide(); 
			PProDialog.showModal(
				title, 
				document.getElementById('centered_dialog').innerHTML + pbutton,
				null,
				null,
				true
			);
		});
	}
}
export function printPopup() {
	// CSS selectors mess up if page is still loading
	if (document.readyState !== "complete") { PProDialog.alert("Wait to print until page fully loads."); return; }
	/* Hide everything that isn't the popup 
	 * Don't touch anything printable */
	var notPopup = document.querySelectorAll('body > *:not(#ppro-common-modal,.printable)');
	notPopup.forEach((elem) => {
		elem.classList.add("noprint-popup");
	});
	window.print();
	notPopup.forEach((elem) => {
		elem.classList.remove("noprint-popup");
	});
}

function recapPrintPreview(pprosono, exceptionMsg){
	window.open("command=printrecap&pprosono="+pprosono+"&exception_note="+exceptionMsg,"recap","toolbar=0,status=0,menubar=0,width=800,height=700,scrollbars=yes,resizable=yes");
}

function viewImage(imgId){
	openWindowCentered("command=viewImage&id=" + imgId, "View Image " + imgId, true);
}


/**********************************************************************************
 *                         PROFILE CHANGE REQUEST
 **********************************************************************************/

/**
 * Utility class. Creates a closure we can call to remove a row from anywhere
 * Need to "prepare" it by adding it to the queue (RowRemover.push(element))
 * then we can call RowRemover.commit() to remove the row.
 */
class RowRemover {
	constructor() {
		this.queue = [];
	}
	/**
	* @param {Node} element This is the Node of either the table row <tr> itself (faster), or an Node in the table row (slower)
	* @param {Boolean} [bForce] If you want to remove the specific element instead of running up the DOM tree to find a <tr>, set to true.
	*/
	push(element, bForce) {
		while (bForce !== true && element.nodeType === Node.ELEMENT_NODE && element.tagName !== "TR" && element.parentNode) {
			element = element.parentNode;
		}
		this.queue.push(  (function() { this.parentNode.removeChild(this); }).bind(element)  );
	}
	pop() {
		this.queue.pop();
	}
	clear() {
		this.queue = [];
	}
	commit() {
		for (var i = 0; i < this.queue.length; i++) {
			this.queue[i].call();
		}
		this.clear();
	}
}
let RowRemoverQueue = new RowRemover();

/**
 * Defines a new product for profile change.  Profile maintenance.
 * Call like new ProfileChange("01234", true).makeRequest(true)
 * @param {string} sProductNo 
 * @param {boolean} bInstant
 */
export class ProfileChange {
	constructor(sProductNo, bInstant) {
		this.bSTOP = false;
		if (typeof sProductNo !== "string") {
			return this.__STOP("Argument sProductNo not passed in or wrong type.");
		}
		this.sProductNo = sProductNo;

		// Allow the old variables from catalyst, convert to new boolean values
		if (typeof bInstant === "string") {
			this.bInstant = (bInstant === "Y") ? true : false;
		} else if (typeof bInstant !== "boolean") {
			return this.__STOP("Argument bInstant not passed in or wrong type.");
		}

		this.BUTTON_NAME = "catalog_profmaint_button";
	}
	/**
	 * Make the request to add/remove from profile.
	 * @param {boolean} bRemoveFromProf If true, remove from profile. False, add to profile. Defaults to false.
	 * @param {boolean} [bRemoveRow] If true, tries to remove the row
	 * @returns A Jquery Deferred object. This is a promise-like object you can use to trigger events.
	 * Deferred resolves after change request completes, otherwise rejects with error message in first argument.
	 */
	makeRequest(bRemoveFromProf, bRemoveRow) {
		if (this.bSTOP) return;
		// Allow the old variables from catalyst, convert to new boolean values
		if (typeof bRemoveFromProf === "string") {
			bRemoveFromProf = (bRemoveFromProf === "Y") ? true : false;
		} else if (typeof bRemoveFromProf !== "boolean") {
			return this.__STOP("Argument bRemoveFromProf not passed in or wrong type.");
		}
		if (typeof bRemoveRow === "string") {
			bRemoveRow = (bRemoveRow === "Y") ? true : false;
		} else if (typeof bRemoveRow !== "boolean") {
			bRemoveRow = false;
		}

		this.lastRemoveFromProf = bRemoveFromProf;
		this.lastRemoveRow = bRemoveRow;

		// Jquery.Deferred helps us manage the lifecycle of this request without needing synchronous requests
		this.deferred = new Promise((resolve, reject) => {
			if (this.bInstant) {
				if (bRemoveRow === true && bRemoveFromProf === true) {
					RowRemoverQueue.push(document.getElementById(this.BUTTON_NAME + this.sProductNo));
				}
				this.doAjax(resolve, reject, bRemoveFromProf);
			} else {
				this.doEmail(resolve, reject, bRemoveFromProf);
			}
		});
		this.deferred.then(() => {
			RowRemoverQueue.commit(); 
		}).catch((err) => { 
			RowRemoverQueue.clear(); /* User cancelled */
		});
		return this.deferred; // allow callee to setup callbacks
	}
	doAjax(resolve, reject, bRemove) {
		if (this.bSTOP) return;

		// Create a Jquery dialog. If yes, submit ajax then resolve this.deferred (e.g. goto callback functions).
		let anchorElem = document.getElementById(this.BUTTON_NAME + this.sProductNo);
		if (anchorElem.offsetHeight == 0) {
			// For grid layout, height is 0 and we tie the popup to the product <tr> instead
			anchorElem = document.getElementById("prod" + this.sProductNo + "qty").closest("tr");
		}
		this.currentDialog = PProDialog.fancyConfirm(this, anchorElem, this.getConfirmTitle(bRemove), this.getConfirmMessage(bRemove),
			{
				[PProWeglot.YES()]: (event) => {
					PProLoading.show();
					PProAjax
						.submit(this.__getCommand(bRemove), this.BUTTON_NAME + this.sProductNo)
						.then(resolve());
					PProLoading.hide();
				},
				[PProWeglot.NO()]: () => {
					reject("User cancelled");
				}
			}
		);
	}
	doEmail(resolve, reject, bRemove) {
		if (this.bSTOP) return;
		this.currentDialog = PProDialog.fancyConfirm(this, document.getElementById(this.BUTTON_NAME + this.sProductNo), this.getConfirmTitle(bRemove), this.getConfirmMessage(bRemove),
			{
				[PProWeglot.YES()]: (event) => {
					PProLoading.show();
					PProAjax
						.submit(this.__getCommand(bRemove))
						.then(resolve());
					event.target.classList.toggle("liked");
					PProLoading.hide();
				},
				[PProWeglot.NO()]: () => {
					reject("User cancelled");
				}
			}
		);
	}
	/**
	* If you want to change the title of the confirmation message, override this method.
	*/
	getConfirmTitle(bRemoveFromProf) {
		return "Profile Change Request";
	}
	/**
	* If you want to change the confirmation message, override this method.
	*/
	getConfirmMessage(bRemoveFromProf) {
		var result = (this.bInstant ? "Are you sure you want to " : "Ask your sales representative to ");
		result += (bRemoveFromProf ? "<b>remove</b>" : "<b>add</b>") + " this product " + (bRemoveFromProf ? "from" : "to") + " your profile?<br>";
		return result;
	}
	/**
	* Helper method to build the command for catalyst
	*/
	__getCommand(bRemove) {
		var cmd = "command=profielcr.ajax";
		cmd += "&prodnum=" + this.sProductNo;
		cmd += bRemove ? "&remove=yes" : "";
		return cmd;
	}
	/**
	* Helper method to stop further action and log errors.
	*/
	__STOP(sMessage) {
		console.error(sMessage);
		this.bSTOP = true;
		if (this.deferred) this.deferred.reject(sMessage);
		return false;
	}
}

/**********************************************************************************
 *                       END PROFILE CHANGE REQUEST
 **********************************************************************************/


function getURLParameter(name, url) {
	if (typeof url === "undefined") url = location.search;
	return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url)||[,""])[1].replace(/\+/g, '%20'))||null;
}

export function trim(s) {
	return s.replace(/^\s+|\s+$/g, "");
}

export function copyToInvoice(){
	var invoiceInst=trim(document.UIservletForm["INVOICEINSTRUCTION"].value);
	var pickInst=document.UIservletForm["PICKINGINSTRUCTION"].value;
	var availableSpace=document.UIservletForm["INVOICEINSTRUCTION"].maxLength - invoiceInst.length - 1;
	if (availableSpace <= 1){
		PProDialog.alert("The Invoicing Instruction is already full.");
		return;
	}
	
	invoiceInst = invoiceInst +" "+pickInst.substr(0,availableSpace);
	document.UIservletForm["INVOICEINSTRUCTION"].value=invoiceInst;
	taCount2(myCounter2,"INVOICEINSTRUCTION");
}

function placeFocus() {
	if (document.forms.length > 0) {
	    for (let x = 0; x < document.forms.length; x++) {
			var field = document.forms[x];
			for (let i = 0; i < field.length; i++) {
				if ((field.elements[i].type == "text") || (field.elements[i].type == "textarea") || (field.elements[i].type.toString().charAt(0) == "s")) {
					if (field.elements[i].id == "txtSearch") {
						// This is used by Indy Fruit to bypass focus on the search field at the top
						continue; 
					}
					try{
						field.elements[i].focus();
						return;
					}catch(error){
						continue;
					}
	           }
	        }
        }
    }
}

//build credit card field array to pass in AJAX submission request
function buildccFieldArray() {
	var ccFieldArray = new Array('AMOUNT', 'PAYMENTCHOICE', 'CCTOKEN', 'CCFN', 'CCMI', 'CCLN', 'CCTYPE', 'CCNUM', 'CCSN', 'CCEXPM', 'CCEXPY', 'EMAL', 'CCADR1', 'CCADR2', 'CCCITY', 'CCSTATE', 'CCZIP', 'CCZIP4');
	var inputs = document.getElementsByTagName("input");
	for(var i = 0; i < inputs.length; i++) {
		if(inputs[i].name.indexOf('amt') == 0) {
			ccFieldArray.push(inputs[i].name);
		}
	}
	return ccFieldArray;
}
//build ACH field array to pass in AJAX submission request
function buildachFieldArray() {
	var achFieldArray = new Array('AMOUNT', 'PAYMENTCHOICE', 'ACHTOKEN', 'ACHNAME', 'ACHTYPE', 'ACHRNUM', 'ACHANUM', 'EMAL', 'CCADR1', 'CCADR2', 'CCCITY', 'CCSTATE', 'CCZIP', 'CCZIP4');
	var inputs = document.getElementsByTagName("input");
	for(var i = 0; i < inputs.length; i++) {
		if(inputs[i].name.indexOf('amt') == 0) {
			achFieldArray.push(inputs[i].name);
		}
	}
	return achFieldArray;
}
// Check that the two copies of ACH number match
export function verifyACHNumber() {	
	if (document.getElementById("ACHANUM").value != document.getElementById("ACHANUM2").value){	
		document.getElementById("ACHSUBMIT").disabled = true;	
		document.getElementById("AccountNumMatch").textContent = "*Account Numbers do not match";	
	} else {	
		document.getElementById("ACHSUBMIT").disabled = false;	
		document.getElementById("AccountNumMatch").textContent = "";	
	}	
}
// Submit Open invoice payment (ajax)
// paymentType: (A)CH or (C)redit
export function openInvoiceSubmitAjax(paymentType) {
	if (typeof doCreditCardTokenization === "function" && !window.ccTokenizationDone) {
		doCreditCardTokenization(function (pType) {
			window.ccTokenizationDone = true;
			openInvoiceSubmitAjax(pType);
		});
		return false;
	}
	// Assume CC, as ACH has limited support
	if (!paymentType || paymentType === "C") {
	    PProLoading.show();
		PProAjax.submit("command=invoicePayment.ccajaxsubmit", 'paymentFormContent', buildccFieldArray())
			.finally(() => { PProLoading.hide(); });
	} else if (paymentType === "A") {
	    PProLoading.show();
	    if ($("[name=ACHCAD_INST]").length > 0) {
			$("[name=ACHRNUM]").val($("[name=ACHCAD_INST]").val() + $("[name=ACHCAD_TRNS]").val())
		}
		PProAjax.submit("command=invoicePayment.achajaxsubmit", 'paymentFormContent', buildachFieldArray())
			.finally(() => { PProLoading.hide(); });
	}
}
// End Open Invoice Functions

window.alreadySubmitted = false;
window.ccTokenizationDone = false;
export function validateCheckout() {
	if (document.readyState !== "complete") {
		return false;
	}

	if (window.alreadySubmitted === true) {
		PProDialog.alert("Your order has already been submitted!");
		return false;
	}

	if (document.UIservletForm["prospect"] && document.UIservletForm["prospect"].value == "Y") {
		PProDialog.alert(document.UIservletForm["prospectmsg"].value);
		return false;
	}
	
	if (document.UIservletForm["PONO1REQUIRED"] && document.UIservletForm["PONO1REQUIRED"].value == "true") {
		var po = document.UIservletForm["PONOONE"].value;
		po = trim(po); 
		if (!po) {
			PProDialog.alert(po1Message);
			return false;
		}
	}
	if (document.UIservletForm["PONO2REQUIRED"] && document.UIservletForm["PONO2REQUIRED"].value == "true") {
		var po = document.UIservletForm["PONOTWO"].value;
		po = trim(po); 
		if (!po) {
			PProDialog.alert(po2Message);
			return false;
		}
	}	
	if (document.UIservletForm["EMAL"]) {
		var email = document.UIservletForm["EMAL"].value;
		email=trim(email);
		if(requireEmailAddress && email == "") {
			PProDialog.alert(emailAddressMessage);
			return false;
		}
	}
	if (document.UIservletForm["DLDT"] && document.UIservletForm["DLDT"].value == "") {
		document.getElementById("DLDTrequired").style.color = "#c30";
		PProDialog.alert(deliveryDateMessage);
		return false;
	}
	// Good to go. Call into any CC tokenization needed.
	if (typeof doCreditCardTokenization === "function" && !window.ccTokenizationDone) {
		doCreditCardTokenization(function () {
			window.ccTokenizationDone = true;
			document.UIservletForm.submit();
		});
		return false;
	}
	
	// Must enabled disabled fields so that non-blank PONOONE and PONOTWO parameters will get passed on 
	document.UIservletForm["PONOONE"].disabled = false;
	document.UIservletForm["PONOTWO"].disabled = false;
	window.alreadySubmitted = true;
	PProLoading.show();
	return true;
}

const alreadyWarnedCAQT = new Set();
function checkAverageQuantityThreshold(sPDNO, qty, qtyField){
	if (alreadyWarnedCAQT.has(sPDNO)) return false;
	var fHighUsage = "usgh_" + sPDNO;
	var fLowUsage = "usgl_" + sPDNO;
	var fAverageUsage = "avgq_" + sPDNO;
	
	if (!document.getElementById(fHighUsage) || !document.getElementById(fLowUsage) || !document.getElementById(fAverageUsage)) {
		return false;
	}
	
	var dialog = document.getElementById("quantityWarning");
	if (dialog == null) {
		return false;
	}
	
	var average = parseFloat(document.getElementById(fAverageUsage).innerHTML);
	if (isNaN(average)) return false;

	var min = parseFloat(document.getElementById(fLowUsage).innerHTML);
	if (isNaN(min)) min = 0;
	
	var max = parseFloat(document.getElementById(fHighUsage).innerHTML); 
	if (isNaN(max)) max = 0;

	if (max != 0 || min != 0) {
		if (qty <= min ||  qty >= max) {
		    alreadyWarnedCAQT.add(sPDNO);
			message = "This is " + (qty <= min ? "less" : "more") + " of product " + sPDNO + " than you usually order. ";
			message += "The average order qty is " + average + ". Click OK to confirm, or Cancel to adjust quantity.";
			PProDialog.showModal(
				"Warning",
				message,
				new DialogButton("OK"),
				new DialogButton([PProWeglot.CANCEL()], () => {
					qtyField.focus();
					qtyField.select();
				})
			);
			return true;
		}
	}
	
	return false;
}

export function validateQuantity(qtyField, sFraction, sThresholdVal, sMinQty, sMaxQty, availQty, substItem, sPDNO, sHasSubItems, sWCOD) {
	var qty = qtyField.value;
	var msg = "";
	var bCutOversell = sWCOD && sWCOD === "Y";
	if (trim(qty) == "") return true;
	if (!isFinite(qty) || parseFloat(qty) < 0) {
		PProDialog.alert("This is an invalid quantity.  Please correct before continuing.", qtyField);
		return false;
	}
	qty = parseFloat(qty);
	if (!isFinite(qty) || parseFloat(qty) < 0) qty = "0";
	if (availQty) {
		availQty = parseFloat(availQty);
		if (!isNaN(availQty)) {
			if (qty > availQty) {
				msg = outOfStockMessage;
				msg = replaceChars(msg, "~avqty", availQty);
				msg = replaceChars(msg, "~prod", sPDNO);
				if (substItem && !bCutOversell) {
					substItem = trim(substItem);
					if (substItem != "") {
						msg = msg + " " + substituteMessage;
						msg = replaceChars(msg, "~substItem", substItem);
					}
				}
				if (bCutOversell) {
					var popupTitle = "Limited stock";
					var confirmBtn = {};
					if (availQty <= 0) {
						popupTitle = "Out of stock";
						msg = "Out of stock.";
					}
					if (sHasSubItems === "true") {
						msg += subOutMessage;
						confirmBtn = {
							[PProWeglot.SUBSTITUTIONS()]: function() {
									var orqtField = document.getElementsByName('orqt_' + sPDNO);
									if (orqtField && orqtField[0]) orqtField[0].value = qty;
									qtyField.value = Math.max(0, availQty);
									// Force cart sync, next move is could be substitute link and we want this data to be saved
									storeQuantities();
									PProAjax.checkSync();
									return substituteitems(sPDNO);
								},
							[PProWeglot.CANCEL()]: function() {
								var orqtField = document.getElementsByName('orqt_' + sPDNO);
								if (orqtField && orqtField[0]) orqtField[0].value = qty;
								qtyField.value = Math.max(0, availQty);
								// Force cart sync, next move is could be substitute link and we want this data to be saved
								storeQuantities();
								PProAjax.checkSync();
							}
						}
					} else {
						msg += " No substitutions are available.";
						confirmBtn = {
							'OK': function() {
								var orqtField = document.getElementsByName('orqt_' + sPDNO);
								if (orqtField && orqtField[0]) orqtField[0].value = qty;
								qtyField.value = Math.max(0, availQty);
								// Force cart sync, next move is could be substitute link and we want this data to be saved
								storeQuantities();
								PProAjax.checkSync();
							}
						}
					}
					PProDialog.fancyConfirm(this, qtyField, popupTitle, msg, confirmBtn);
				} else {
					PProDialog.alert(msg, qtyField);
				}
				return false;
			}
		}
	}
	if (qty > 0 && (sMinQty || sMaxQty)) {
		var iMinQty = parseFloat(sMinQty);
		var iMaxQty = parseFloat(sMaxQty);
		if (!isNaN(iMinQty) && iMinQty > 0) {	
			if (qty < iMinQty) {
				PProDialog.alert('A minimum of ' + iMinQty + ' items are allowed for product ' + sPDNO + '.  Please change the quantity ordered.', qtyField);	
				return false;
			}
		}
		if (!isNaN(iMaxQty) && iMaxQty > 0) {
			if (qty > iMaxQty) {
				PProDialog.alert('A maximum of ' + iMaxQty + ' items are allowed for product ' + sPDNO + '.  Please change the quantity ordered.', qtyField);	
				return false;
			}
		}
	}
	// Check if they are ordering above or below their historical average
	if (checkAverageQuantityThreshold(sPDNO, qty, qtyField)) {
		return false;
	}
	// ( ) for Any fraction, (H)alves only, (Q)uarters only, or (W)hole Numbers only.
	var testCriteria = 1.00;	
	if (!requireIntQty && sFraction != null) {
		if (sFraction == "H") testCriteria = 0.50;
		if (sFraction == "Q") testCriteria = 0.25;
		if (trim(sFraction) == "") testCriteria = 0.00;
	}
	if ((testCriteria != 0) && (qty % testCriteria != 0)) {
		PProDialog.alert((testCriteria == 1.00 ? qtyMessage : getFractionMessage(testCriteria)), qtyField);
		return false;
	}
	// This needs to be the last check because user can say 'Yes' and keep the quantity value,
	// which means all the other quantity validation checks need to happen first.
	if (sThresholdVal) {
		var iThresholdQty = sThresholdVal;
		iThresholdQty = parseFloat(iThresholdQty);
		if (!isNaN(iThresholdQty)) {
			if (qty >= iThresholdQty) {
				PProDialog.fancyConfirm(this, qtyField, 'Over Quantity Threshold', 'Are you sure you want to add that many items?', {
					[PProWeglot.YES()]: function () {
						setTimeout(function()
						{
							doTabNext(qtyField);
						}, 0);
						return true;
					},
					[PProWeglot.NO()]: function () {
						// JWB | 2017-09-15 | Workaround for a WontFix bug in Chrome
						// where calling focus() during a blur handler triggers a blur event
						// save blur event
						var prevBlur = qtyField.onblur;
						// remove handler
						qtyField.onblur = null;
						setTimeout(function() {
							qtyField.focus();
							qtyField.select();
							// restore handler
							qtyField.onblur = prevBlur;
						}, 0)
						return false;
					}
				});
			}
		}
	}
	
	// SRP related
	if (calculateGrossSales) {
		try {
			var sSprc = document.getElementById("sprc_" + sPDNO).innerHTML;
			var sMult = document.getElementById("mult_" + sPDNO).innerHTML;
			var sPackCount = trim(document.getElementById("pack_count_" + sPDNO).innerHTML);
			PProProfile.displayGrossSales(sMult, sSprc, qty, 'grossSales_' + sPDNO, sPackCount);
		} catch(e) {
			// do nothing
		}			
	}
	
	return true;
}

function checkProblems() {
	var problem = document.forms.UIservletForm["PROBLEM"];
	if (problem) {
		PProDialog.alert(problem.value);
	}
}

export function alertField(qtyField, theMessage){
	PProDialog.alert(theMessage, qtyField);
}

function replaceChars(txt, search, replaceWith) {
	let out = search; // replace this
	let add = replaceWith; // with this
	let temp = txt; // temporary holder
	
	while (temp.indexOf(out) > -1) {
		pos = temp.indexOf(out);
		temp = temp.substring(0, pos) + add + temp.substring(pos + out.length, temp.length);
	}
	return temp;
}

/*
   name - name of the cookie
   value - value of the cookie
   [expires] - expiration date of the cookie
     (defaults to end of current session)
   [path] - path for which the cookie is valid
     (defaults to path of calling document)
   [domain] - domain for which the cookie is valid
     (defaults to domain of calling document)
   [secure] - Boolean value indicating if the cookie transmission requires
     a secure transmission
   * an argument defaults when it is assigned null as a placeholder
   * a null placeholder is not required for trailing omitted arguments
*/

function setCookie(name, value, expires, path, domain, secure) {
  var curCookie = name + "=" + escape(value) +
      ((expires) ? "; expires=" + expires.toGMTString() : "") +
      ((path) ? "; path=" + path : "") +
      ((domain) ? "; domain=" + domain : "") +
      ((secure) ? "; secure" : "");
  document.cookie = curCookie;
}


/*
  name - name of the desired cookie
  return string containing value of specified cookie or null
  if cookie does not exist
*/

function getCookie(name) {
  var dc = document.cookie;
  var prefix = name + "=";
  var begin = dc.indexOf("; " + prefix);
  if (begin == -1) {
    begin = dc.indexOf(prefix);
    if (begin != 0) return null;
  } else
    begin += 2;
  var end = document.cookie.indexOf(";", begin);
  if (end == -1)
    end = dc.length;
  return unescape(dc.substring(begin + prefix.length, end));
}


/*
   name - name of the cookie
   [path] - path of the cookie (must be same as path used to create cookie)
   [domain] - domain of the cookie (must be same as domain used to
     create cookie)
   path and domain default if assigned null or omitted if no explicit
     argument proceeds
*/

function deleteCookie(name, path, domain) {
  if (getCookie(name)) {
    document.cookie = name + "=" +
    ((path) ? "; path=" + path : "") +
    ((domain) ? "; domain=" + domain : "") +
    "; expires=Thu, 01-Jan-70 00:00:01 GMT";
  }
}

// date - any instance of the Date object
// * hand all instances of the Date object to this function for "repairs"

function fixDate(date) {
  var base = new Date(0);
  var skew = base.getTime();
  if (skew > 0)
    date.setTime(date.getTime() - skew);
}

function zeroPad(value, theLength){
	for(i=value.length;i<theLength;i++){
		value="0"+value;
	}
	return value;
}

/************* For Copyright in footer *********/
Date.prototype.getFullYear = getFullYear;

function getFullYear(){
	var n = this.getYear();
	if (n < 1000) n += 1900; // needed for netscape and IE 7
	return n;
}

function insDate(){
	today = new Date();
	result = (today.getFullYear());
	document.write(result);
}

/**
 * checks all checkboxes on a document
 * depends on the type being "checkbox"
 */
function setAllCheckBoxes(state) {
   	for (i = 0; i < document.UIservletForm.elements.length; i++) {
        if (document.UIservletForm.elements[i].type == 'checkbox')
            document.UIservletForm.elements[i].checked = state;
    };
}

/*********************************
 * Profile / Catalog Script
 * All elements with a title attribute value ending with ".JPG" will get turned into tooltip windows
***********************************/
function profileCatalogPageTooltipSetup() {
	$(function() {
		$(document).tooltip({
			items : "[title$='.JPG']", 
			position : {
				my: "left+35",
				at: "right+10",
				collision: "flipfit"
			},
			content : function() {
				var sHeight = "400";
				var sURL = $(this).attr("title");
				if (sURL.indexOf("PRODUCT_INFO") > 0) {
					sHeight = "512";
				}
				return "<img src=\"" + sURL + "\" width=\"400\" style=\"object-fit: cover;\" height=\"" + sHeight + "px;\">";
			},
			open : function(event, ui) {
				var sHeight = "400";
				if (ui.tooltip[0].innerHTML.indexOf("PRODUCT_INFO") > 0) sHeight = "512";
				ui.tooltip.css("min-height", sHeight + "px");
				ui.tooltip.css("min-width", "400px");
			}
		});
	});
}

//Gather values of all orderq fields on the page, put in array, and then submit a request to write out the shopping cart
export function storeQuantities() {
	if (processing == true) return; /* page still loading */
	if (navigator.userAgent.match(/iPad/i) != null) {
		return; // Don't do any of this for iPad devices
	}
	var fields = new Array();

	// invqty are profile only
	var invqtyExists = document.querySelector("td:not(.hidden)>input[name^=invqty_]") != null;
	
	document.querySelectorAll( "input[name^=orderq]" ).forEach((elem) => {
		var sName = elem.getAttribute("name");
		if (typeof sName === "undefined") return;
		// orderq02620@10.00
		var sValue = document.UIservletForm[ sName ].value;			
		var sPdno = sName.substring(6).split("@")[0];			

		fields.push(sName);
		fields.push("ndlt_" + sPdno);
		fields.push(sPdno + "_seq");
		fields.push("orqt_" + sPdno);
		if (invqtyExists) fields.push("invqty_" + sPdno);
	});

	var arrNewValues = "";
	for (let i = 0; i < fields.length; i++) { 
		if (!fields[i].includes("orderq")  && !fields[i].includes("invqty")) continue;
		arrNewValues += (i > 0 ? "," : "") + document.UIservletForm[fields[i]].value;
	}
	
	if (arrNewValues != arrOldValues) {
		// Something changed, submit it
		arrOldValues = arrNewValues;

		// this should work even if floating cart div is not present
		PProAjax.sync('orderqajax', "command=orderqajax&parm=nothing&axseqn=" + PProAjaxSequence.getNext(), "FloatingCart", fields,
			() => {
				SystemPage.populateCartItems();
			}
		);
	}
}

function formatCurrency(num) {
	num = num.toString().replace(/\$|\,/g,'');
	if(isNaN(num))	num = "0";
	sign = (num == (num = Math.abs(num)));
	num = Math.floor(num*100+0.50000000001);
	cents = num%100;
	num = Math.floor(num/100).toString();
	if(cents<10) cents = "0" + cents;
	for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++){
		num = num.substring(0,num.length-(4*i+3))+','+ num.substring(num.length-(4*i+3));
	}
	return (((sign)?'':'-') + '$' + num + '.' + cents);
}
/*********** END SRP Profile ************/

/* secondary price list support */
function changeSecondaryPriceList() {
	document.UIservletForm["parm"].value="nothing";
	document.UIservletForm["nextCommand"].value="changespricelist";
	document.UIservletForm["name"].value="profile";
	PProLoading.show();
	document.UIservletForm.submit();
}

/* Utility function to help open/close mobile menus. Useful when copying a web design and removing the original javascript */
var bMobileMenuVisible = false;
function toggleMobileMenu(sMenuSelector) {
	bMobileMenuVisible = !bMobileMenuVisible;
	const navElement = document.querySelector(sMenuSelector);
	if (bMobileMenuVisible) {
		navElement.classList.remove("mobileHidden");
	} else {
		navElement.classList.add("mobileHidden");
	}
}

/** START contact maintenance **/

export function disableOtherButtons() {
	document.querySelectorAll('.disable-when-editing').forEach((elem) => {
		elem.setAttribute("disabled", "");
	});
}

export function enableOtherButtons() {
	document.querySelectorAll('.disable-when-editing').forEach((elem) => {
		elem.removeAttribute("disabled");
	});
}

/**
 * Initialize form to toggle WBID and WBPW fields on "OL" contact selection
 */
export function disableWbidField() {
	var olAllChecks = Array.from(
			document.querySelectorAll('input')
		).filter((elem) => {
			if (elem.dataset.ol === "Y") return true;
			else return false;
		});
	olAllChecks.forEach((elem) => {
		elem.addEventListener("click", toggleWbidField);
	});
	toggleWbidField();
}
/**
 * Toggle "disabled" attr on WBID and WBPW field on contact maintenance
 * @param {Boolean} override Forcefully disable or enable a field.
 */
function toggleWbidField (override) {
	var olAll = $('input').filter(function(idx, elem) {
		if ($(elem).data("ol") === "Y") {
		return true;
		}
		else return false;
	});
	var olUnChecked = olAll.not(':checked');
	var olToggle = olAll.parents('.customertab').find('.ol-toggle');
	var disable = !!olUnChecked.length;
	if (typeof override === 'boolean') {
		disable = override;
	}
	if (disable) {
		function toggleClickEvent() {
		return function(event) {
			PProDialog.fancyConfirm(window, event.target, "Cannot add login information", 'You must check "Online Login" under "Contact type(s)" to fill in login information', {
				"OK": () => {}
			});
		}
		};
		olToggle.addClass('ol-disabled');
		var wbid = olToggle.find("#CONT_WBID");
		var tmpVal = wbid.val();
		if (tmpVal) wbid.data("val", tmpVal).val("");
		olToggle.on("click", toggleClickEvent());
	} else {
		olToggle.removeClass('ol-disabled');
		var wbid = olToggle.find("#CONT_WBID");
		var tmpVal = wbid.data("val");
		if (tmpVal) wbid.val(tmpVal).data("val", "");
		olToggle.off('click');
	}
	olToggle.find('input').prop('disabled', disable);
}

/**
 * Check if OL checked && WBID and WBPW filled in.
 * Only returns false if OL checked and id or password not filled in
 */
export function chkWbid() {
	var olAll = $('input').filter(function(idx, elem) {
		if ($(elem).data("ol") === "Y") {
		return true;
		}
		else return false;
	});
	var olUnChecked = olAll.not(':checked');
	var bOlExists = !!olAll.length;
	var bAnyUnchecked = !!olUnChecked.length;
	if (bOlExists && !bAnyUnchecked) {
		// OL contact type checked. Require WBID and WBPW filled out
		var WBID = olAll.parents('.customertab').find('input[name="CONT_WBID"]');
		var WBPW = olAll.parents('.customertab').find('input[name="CONT_WBPW"]');

		// login credentials missing because credential editing is disabled
		if (WBID.length == 0 && WBPW.length == 0)  {
			// allow saving for other settings
			return true;
		}

		var bWBIDFilledIn = !!WBID.val();
		if (WBPW.data("filled") !== true) {
			// Password does not not exist on PPro contact. Force user to enter one.
			var bWBPWFilledIn = !!WBPW.val();
			if (!(bWBIDFilledIn && bWBPWFilledIn)) {
				PProDialog.alert('Cannot save contact: missing required information. Please fill in a Web ID and Password or uncheck "Online Login"');
			}
			return (bWBIDFilledIn && bWBPWFilledIn);
		} else {
			if (!bWBIDFilledIn) {
				PProDialog.alert('Cannot save contact: missing required information. Please fill in a Web ID or uncheck "Online Login"');
			}
			return bWBIDFilledIn;
		}
	} 
	// ol unchecked, or non-existant.
	return true;
}

/**
 * Delete a contact
 */
export function confirmDeleteContact(event, cust, contactId, seqn, row, contName) {
	console.log(arguments)
	PProDialog.fancyConfirm(window, event.target,
		'Delete Contact',
		`Are you sure you want to delete contact '${contName ? contName : ''}'?`,
		{
			[PProWeglot.YES()]: () => {
				event.target.closest('.customertab').classList.add("hidden")
				PProAjax.submit("command=ContactHandler.editSubmit&customer="+cust+'&cnid='+contactId+'&seqn='+seqn+'&ROW='+row+'&new=N&CONT_INFG=Y&CONT_NAME=' + encodeURIComponent(contName));
			},
			[PProWeglot.NO()]: () => {}
		}
	);
	return true;
}

/**  END Contact maintenance **/
/**
 * Google Analytics 
 **/
export function gaAddOnOrder() {
	if (typeof window.gtag === "function")	{
		window.gtag('event', 'Order Entry - Add-On Order Started', {		
		  'event_category': 'order entry',
		  'event_label': 'Add-On Order Started'
		});
	}
}
export function gaEditOrder() {
	if (typeof window.gtag === "function")	{
		window.gtag('event', 'Order Entry - Edit Order Started', {		
		  'event_category': 'order entry',
		  'event_label': 'Edit Order Started'
		});
	}
}
export function gaVoidOrder() {
	if (typeof window.gtag === "function")	{
		window.gtag('event', 'History - Voided Order', {		
		  'event_category': 'history',
		  'event_label': 'Order Voided'
		});
	}
}
export function gaOrderDetailViewed(sSONO) {
	if (typeof window.gtag === "function")	{
		window.gtag('event', 'History - Viewed Order Detail', {		
		  'event_category': 'history',
		  'event_label': 'Viewed Order Detail'
		});
	}
}
export function gaCarouselProductDetailEvent(sCarouselType, sPDNO) {
	if (typeof window.gtag === "function")	{
		window.gtag('event', sCarouselType + ' Carousel - Product[' + sPDNO + '] Detail', {		
		  'event_category': sCarouselType + ' event',
		  'event_label': 'Product[' + sPDNO + '] Detail'
		});
	}
}
export function gaCarouselProductAddedEvent(sCarouselType, sPDNO) {
    if (typeof window.gtag === "function")	{
		window.gtag('event', sCarouselType + ' Carousel - Product[' + sPDNO + '] Added to Cart', {		
		  'event_category': sCarouselType + ' event',
		  'event_label': 'Product[' + sPDNO + '] Added to Cart'
		});
	}
}
export function gaCarouselPageEvent(sCarouselType, sDirection) {
    if (typeof window.gtag === "function")	{
		window.gtag('event', sCarouselType + ' Carousel - ' + sDirection +'Page', {		
		  'event_category': sCarouselType + ' event',
		  'event_label': sDirection +'Page'
		});
	}
}
export function gaPushListButtonEvent(sPushListcode) {
	if (typeof window.gtag === "function")	{
		window.gtag('event', 'Push List Button - Push List Code['+sPushListcode+']', {		
		  'event_category': 'Push List Button',
		  'event_label': 'Push List Code['+sPushListcode+']'
		});
	}
}
export function gaSearchEvent(sDescription, bPublic = false) {
	if (typeof window.gtag === "function")	{
		window.gtag('event', 'Keyword Search - Type: Freeform', {
		  'event_category': 'search',
		  'event_label': (bPublic ? 'Public Catalog ' : '') + 'Search For: ' + sDescription
		});		
	}
}
export function gaMenuSearchEvent(sDescription) {
	if (typeof window.gtag === "function")	{
		window.gtag('event', 'Catalog Search - Type: CLAS', {
		  'event_category': 'search',
		  'event_label': 'Search For CLAS: ' + sDescription
		});		
	}
}
/**
 * When user choice, grab value from sessionStorage or default to catalog search
 */
function setCatalogSearchRadio() {
	var catalogSearchPref = sessionStorage.getItem("catalogSearchPref");
	var elemProfile = document.getElementById("searchselect_profile");
	var elemCatalog = document.getElementById("searchselect_catalog");

	if (elemCatalog && catalogSearchPref === elemCatalog.value) {
		elemCatalog.checked = true;
	} else if (elemProfile && catalogSearchPref === elemProfile.value) {
		elemProfile.checked = true;
	}

	elemCatalog.addEventListener("click", setCatalogSearchPref);
	elemProfile.addEventListener("click", setCatalogSearchPref);
}

function setCatalogSearchPref(event) {
	if (event && event.target && event.target.value) {
		sessionStorage.setItem("catalogSearchPref", event.target.value);
	}
}

function createAndSendRestaurantwareForm(data) {
	if (data.error) {
		PProDialog.alert(data.error);
		return;
	}
	document.body.innerHTML += '<form id="rwform" class="hidden" method="post" action="' + data.action + '">' +
		'<input name="did" value="' + data.did + '">' +
		'<input name="cid" value="' + data.cid + '">' +
		'<input name="token" value="' + data.token + '">' +
		'<input name="email" value="' + data.email + '">' +
	'</form>';
	document.querySelector("#rwform").submit();
	
}
/*********** END Browse Catalog ************/

function loginPublicCustomer(action, login, pass) {
	// Sanity check -- log the user out if they are logged in
	PProFetch(action + "?command=iosignoff&force=Y")
		.finally(() => {
			const pcForm = new FormData();
			pcForm.append("command", "standbylogin");
			pcForm.append("CUSTOMER_ID", login);
			pcForm.append("PASSWORD", pass);
			PProFetch(action, {body: pcForm});
		});
}

/*** Begin Credit Card and Open Invoice Payment Support ***/

export function updateCardType() {
	var number = document.getElementById("CCNUM").value;
    var re = {
        vs: /^4[0-9]{6,}$/,
        mc: /^5[1-5][0-9]{14}$/,
        am: /^3[47][0-9]{5,}$/,
        dc: /^3(?:0[0-5]|[68][0-9])[0-9]{4,}$/,
        ds: /^6(?:011|5[0-9]{2})[0-9]{3,}$/
    };
    var cctype = document.getElementById("CCTYPE");
    if (cctype) {
	    if (re.vs.test(number)) cctype.value = 'VS';
	    else if (re.mc.test(number)) cctype.value = 'MC';
	    else if (re.am.test(number)) cctype.value = 'AM';
	    else if (re.ds.test(number)) cctype.value = 'DS';
	    else if (re.dc.test(number)) cctype.value = 'DC';
		else if (number.trim() === '') cctype.value = '';
		else cctype.value = 'OT'; // other
    }
};

/*
* If getConvenienceFee() exists, it will used to pass the fee to this function. Otherwise, 
* we send the card type to the front end Java code to figure out the fee from the card type.
*/ 
export function updateConvenienceFee(value) {
	if (typeof getConvenienceFee === "function") {
		if (value == '') return; // invalid fee
		// Fee is already known on browser side, so we just send it to the Java side
		parms = "&FEE=" + value
	} else {
		if (value.length <= 12) return; // invalid card number
		// We don't know the fee and send the card type to the Java side so it can make an API call to calculate it
		parms = "&CCTYPE=" + value;
	}
	if (document.getElementById('paymentBreakdown')) {	
		PProAjax.submit("command=updateConvenienceFee" + parms, "paymentBreakdown");	
	} else if (document.getElementById('openInvoicePaymentBreakdown')) {
		PProAjax.submit("command=InvoicePayment.updateConvenienceFee" + parms, "openInvoicePaymentBreakdown", ["AMOUNT"]);	
	}
}

//Open Invoice Functions
export const OpenInvoice = {
	initialize: () => {
		if (!PProUtil.CheckJsOnLoad("OpenInvoice.initialize")) return;
		OpenInvoice.manageFieldEntry();
		var sumCopies = document.getElementsByClassName("partial_sum_copy")
		for (var j1 = 0; j1 < sumCopies.length; j1++) {
			sumCopies[j1].innerHTML = document.getElementById("partial_sum_text").innerHTML;
		}
		window.addEventListener("pageshow", function() {
			document.getElementById("r1").checked = true;
		});
		$(".entryon-partial").each(function(idx, elem) {
			let blam = $(elem).attr("data-blam");
			if (blam && typeof(blam) !== 'number' && blam.charAt(0) === '-') {
				elem.innerHTML = "Use Balance";
			}
		});
		var tableOpenInvoices = $("#openinvoices");
		if (tableOpenInvoices && tableOpenInvoices.length > 0) {
			// OLD Data tables Library
			tableOpenInvoices.dataTable({
				"bPaginate": false,
				"bFilter": false, // turn off search
				"bStateSave": true,
				"stripeClasses": [ 'even', 'shaded' ]
			});
		}
	},
	validateFixedAmount: () => {
		var fixedamt = document.getElementById("fixedamt");
		var value = fixedamt.value;
		var maximumValue = document.getElementById("spantotalamt").innerText;
		
		if (+value > +maximumValue) {
			OpenInvoice.showMessage(fixedamt, "The fixed amount value must be smaller than the total invoice balance.");
			return false;
		} else {
			OpenInvoice.hideMessages();
			fixedamt.style.backgroundColor = "";
			return true;
		}
	},
	validateAmount: (id, name, balance) => {
		var retval = true;
		var amount = document.getElementById(id);
		amount.value = amount.value.replace("$", "");
		amount.value = amount.value.replace(",", "");
		var val = trim(amount.value);
		balance = balance.replace(",", "");
		balance = trim(balance);
		amount.style.backgroundColor = ""; 
		if (val != "") {
			var regxAmount;
			var negativeRequired = balance.charAt(0) === '-';
			if (negativeRequired) regxAmount = /^-\d*(\.\d{1,2})?$/;
			else regxAmount = /^\d*(\.\d{1,2})?$/;
			if (val.search(regxAmount) == -1) {
				OpenInvoice.showMessage(amount, "The " + name + " must be a valid "  + (negativeRequired ? "negative" : "") + " amount.");
				retval = false;
			}
			if (Math.abs(+val) > Math.abs(+balance)) {
				// Make sure they do not over pay a balance or take a larger credit than they have available
				if (negativeRequired) OpenInvoice.showMessage(amount, "The specified credit " + name + " is too large.");
				else OpenInvoice.showMessage(amount, "The " + name + " must be smaller than the invoice balance.");
				retval = false;
			}
		}
		return retval;
	},
	validatePartialAmounts: () => {
		var invoiceNumber;
		var retval = true;
		document.querySelectorAll("table#openinvoices input[type=text]").forEach(function(elem) {
			invoiceNumber = elem.id.slice(3);
			if(!isNaN(elem.value) && !OpenInvoice.validateAmount(elem.id, "amount for invoice " + invoiceNumber, document.getElementById("blam" + invoiceNumber).value)) {
				retval = false;
			}
		})
		if (retval) OpenInvoice.hideMessages();
		return retval;
	},
	hideMessages: () => {
		document.getElementById("error_message").className = "hidden";
		var submitBtns = document.getElementsByClassName("paymentSelectionSubmit");
		for (var j1 = 0; j1 < submitBtns.length; j1++) {
			submitBtns[j1].disabled = false;
		}
	},
	showMessage: (f1, message) => {
		if (f1 != null) placeFocus(f1);
		document.getElementById("error_message_text").innerHTML = message;
		document.getElementById("error_message").className = "";
		if (f1 != null) f1.style.backgroundColor = "#ffcccc";
		var submitBtns = document.getElementsByClassName("paymentSelectionSubmit");
		for (var j1 = 0; j1 < submitBtns.length; j1++) {
			submitBtns[j1].disabled = true;
		}
	},
	calculateNewTotal: () => {
		var total = 0;
		document.querySelectorAll("table#openinvoices input[type=text]").forEach((elem) => {
			if(!isNaN(elem.value)) {
				total = +total + +elem.value; // '+' trick adds numbers instead of concat strings
			}
		})
		var formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		});
		document.getElementById("partial_sum").innerHTML= formatter.format(parseFloat(total.toFixed(2)));
		var sumCopies = document.getElementsByClassName("partial_sum_copy")
		for (var j1 = 0; j1 < sumCopies.length; j1++) {
			sumCopies[j1].innerHTML = document.getElementById("partial_sum_text").innerHTML;
		}
		OpenInvoice.validatePartialAmounts();
	},
	validatePaymentChoice: () => {
		var value;
		OpenInvoice.hideMessages();
		if (document.getElementById("r1").checked) {
			value = document.getElementById("totalamt").value;
			if (isNaN(value) || +value <= 0) {
				OpenInvoice.showMessage(null, "Something went wrong.  The full amount value is invalid.");
				return false;
			}	
		} else if (document.getElementById("r2").checked) {
			value = document.getElementById("fixedamt").value;
			if (isNaN(value) || +value <= 0 || !OpenInvoice.validateFixedAmount()) {
				OpenInvoice.showMessage(document.getElementById("fixedamt"), "Please enter a valid 'fixed' amount.");
				return false;
			}		
		} else if (document.getElementById("r3").checked) {
			value = document.getElementById("partial_sum").innerHTML;
			value = value.replace(",", ""); 
			value = value.replace("$", ""); 
			if (isNaN(value) || +value <= 0 || !OpenInvoice.validatePartialAmounts()) {
				if (value <= 0) OpenInvoice.showMessage(null, "Please enter valid payment amounts into the table below.");	
				else OpenInvoice.showMessage(null, "Something went wrong.  The partial amount value is invalid.");	
				return false;
			}
		}
		PProLoading.show();
		return true;
	},
	/*
	* Disables/enables fields depending on current radio button selection.
	* Just put "entryon-" classes on an input field to enable/disable it.
	* Multiple "entryon-" classes can be placed on the same field.
	* Only other "entryon-" fields will be managed, so a field without any
	* of these classes will not be messed with.
	*/
	manageFieldEntry: () => {
		var currField = document.querySelector("input[name=PAYMENTCHOICE]:checked").value,
			showOnOther = document.querySelectorAll(".entryon-other"),
			showOnPartial = document.querySelectorAll(".entryon-partial");
		if (currField === "other") {
			// Sets may overlap, so disable first then enable.
			OpenInvoice._setFieldsDisabled(showOnPartial, true, showOnOther, false);
			OpenInvoice.validateFixedAmount();
		} else if (currField === "partial") {
			OpenInvoice._setFieldsDisabled(showOnPartial, false, showOnOther, true);
			OpenInvoice.validatePartialAmounts();
		} else {
			OpenInvoice._setFieldsDisabled(showOnPartial, true, showOnOther, true);
			OpenInvoice.hideMessages();
		}
	},
	/*
	* Disables/enables two sets of fields. The second set is optional & for convenience.
	* Using readonly stops editing but still allows the field to be submitted if necessary.
	* a & b are jQuery elements
	* isADisabled & isBDisabled are booleans
	*/
	_setFieldsDisabled: (a, isADisabled, b, isBDisabled) => {
		a.forEach((elem) => {
			elem.disabled = isADisabled
		});
		if (!b) return;
		b.forEach((elem) => {
			elem.disabled = isBDisabled
		});
	}
}

/*** End Credit Card and Open Invoice Payment Support ***/

function getPageTitle() {
    var pageElem = document.querySelector(".page-heading");
    var pageTitle = pageElem === null ? "" : pageElem.innerText;
    if (trim(pageTitle) === "") {
    	pageTitle = document.querySelector('meta[name=catalyst-cmd-desc]')?.getAttribute("content");
    	if (!pageTitle || trim(pageTitle) === "") {
    		pageTitle = document.querySelector('meta[name=catalyst-cmd]')?.getAttribute("content");
    	}
    }
	return pageTitle;
}

// product quantity increment/decrement button code
export function quantityButtonClick(mode, id) {
    // doing this loop because if floating cart is present, there are quantity fields with duplicate ID's
	Array.prototype.slice.call(document.querySelectorAll('.inputQty')).some(function(quantityElem){
		if (quantityElem.id === id) {
			var oldQty = Number(quantityElem.value);
			var newQty;
			if (mode === "-") {
				newQty = oldQty - 1;
				if (newQty < 0) newQty = 0;
			} else {
				newQty = oldQty + 1;
			}
			quantityElem.value = newQty;
			// blur is needed to trigger quantity validation checks, followed by storeQuantities()
			quantityElem.focus();
			quantityElem.blur();
			return true; // short circut loop
		}
		return false;
    });
}

function castQuantityToNumber(pdno) {
	var quantityElem = document.getElementById("prod" + pdno + "qty");
	quantityElem.value = Number(quantityElem.value);
}
// end product quantity increment/decrement button code

/* START Cart page functions */

export const PProCart = {
	lastWidth: 450,
	initialize: () => {
		if (!PProUtil.CheckJsOnLoad("PProCart.initialize")) return;

		if (!PProCart.useServerSideRecalc()) {	
			$(".submitUpdate").each(function(e) {
				$(this).remove(); // hide 'update' button
			});
		}
		document.querySelector(".cart-wrapper")?.addEventListener("click", (event) => {
			event.preventDefault();
			if (PProCart.validateCartForm()) {
				var updateBtn = document.createElement('input');
				updateBtn.type = 'hidden';
				updateBtn.name = 'function_update';
				updateBtn.value = 'Update Quantities';
				document.UIservletForm.append(updateBtn);
				document.UIservletForm.submit();
			}
		});
		PProCart.initCarousel();
		// Responsive. When going under a certain size, trigger grid view
		const switchMobileLayout = () => {
			if (PProCart.lastWidth >= 450 && window.innerWidth < 450) {
				PProCart.lastWidth = window.innerWidth;
				document.querySelectorAll(".cart .table__wrapper")?.forEach(elem => elem.setAttribute("data-view", "grid"));
			} else if (PProCart.lastWidth < 450 && window.innerWidth >= 450) {
				PProCart.lastWidth = window.innerWidth;
				document.querySelectorAll(".cart .table__wrapper")?.forEach(elem => elem.setAttribute("data-view", "list"));
			}
		}
		switchMobileLayout();
		window.addEventListener("resize", switchMobileLayout);
	},
	initCarousel: () => {
		if (!PProUtil.CheckJsOnLoad("PProCart.initCarousel")) return;

		let slideCount = $(".slickify.suggestedItems-carousel").children().length;
		$('.slickify.suggestedItems-carousel').slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: Math.min(slideCount, 4),
			slidesToScroll: Math.min(slideCount, 4),
			responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: Math.min(slideCount, 3),
					slidesToScroll: Math.min(slideCount, 3),
					infinite: true,
					dots: false
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: Math.min(slideCount, 2),
					slidesToScroll: Math.min(slideCount, 2),
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
			]
		}); 
	},
	validateCartForm: () => {
		var isCartValid=true;
		var index=0;
		var fieldName="";
		do {
			const fieldName="QNTY_"+index;
			const avQtyFieldName="AVQT_"+index;
			const substFieldName="SUPD_"+index;
			const fractFieldName="PQVL_"+index;
			const sMinQty = "MNQT_" + index;
			const sMaxQty = "MXQT_" + index;
			const sPDNO = "PROD_" + index;
			if (document.forms.UIservletForm[fieldName]) {
				if (!validateQuantity(document.UIservletForm[fieldName], document.UIservletForm[fractFieldName].value, null, document.UIservletForm[sMinQty].value, document.UIservletForm[sMaxQty].value, document.UIservletForm[avQtyFieldName].value, document.UIservletForm[substFieldName].value, document.UIservletForm[sPDNO].value)) {
					isCartValid=false;
					break;
				} else{
					isCartValid=true;
					index++;
				}
			} else {
				break;
			}
		} while(true);
		return isCartValid;
	},
	useServerSideRecalc: () => {
		if (document.getElementById("taxshown")) return true;  // tax is being displayed.  	
		if (document.getElementById("samtshown")) return true;  // service amount displayed. 	
		if (document.getElementById("COUPONCODE")) return true; // coupon support is on	
		if (!document.forms.UIservletForm["pricing"]) return true; // some items don't have prices	
		return false;
	},
	// Update additionalCharges section
	serverSideAjaxRecalc: (qField, date) => {
		if (document.getElementById("additionalCharges")) {
			var sPDNO = qField.id.slice(4, 9);
			var sQNTY = qField.value;
			if (sQNTY.trim() == "") {
				// non numeric string check
				qField.value = 0;
				sQNTY = "0";
			}
			if (sQNTY.trim() == "") {
				// non numeric string check
				qField.value = 0;
				sQNTY = "0";
			}
			var sPrice = document.getElementById("price_" + sPDNO + "_" + date).innerText.slice(1);
			var newAmount = (sQNTY * sPrice).toFixed(2);
			var oldAmount = document.getElementById("amount_" + sPDNO + "_" + date).innerText.slice(1);
			if (newAmount.trim() != oldAmount.trim()) {
				// do back end calculation
				PProLoading.show();
				PProAjax.submit(
					"command=recalculateCart.ajax&PDNO=" + sPDNO + "&QNTY=" + sQNTY,
					"additionalCharges", 
					new Array()
				).finally(() => { 
					PProLoading.hide(); 
					
					// update product line
					document.querySelector("#amount_" + sPDNO + "_" + date).innerText = "$" + newAmount;

					// minimum $ amount check
					var iTotalAmnt = parseFloat(document.getElementById("totalamnt_" + date).innerHTML);
					var iAmnt = document.getElementById("AMNTREQ").value - iTotalAmnt;
					if (iAmnt <= 0) {
						iAmnt = 0;
						document.getElementById("minamnt_" + date).className = "";
					} else {
						document.getElementById("minamnt_" + date).className = "minnotmet";
					}
					document.getElementById("minamnt_" + date).innerHTML = PProCart.formatNumber(iAmnt);
				});
			}
		}
	},
	cart_updateTotals: (qField, date, useAllDatesForTotals) => {
		var iQtyTotal = 0;
		var iAmntTotal = 0;
		var iCasesTotal = 0;
		if (!PProCart.validateCartForm()) return;
		var parms = "";
		document
			.querySelectorAll("#cartTable_" + date + " input:not([type=hidden])")
			.forEach((elem) => {
				if (!elem.hasAttribute("name") || !elem.getAttribute("name").startsWith("QNTY_")) return;
				var iIndex =elem.getAttribute("name").substring(5, 6);		
			
				var sPROD = document.getElementsByName("PROD_" + iIndex)[0].value;
				var sCSEQ = document.getElementsByName("CSEQ_" + iIndex)[0].value;
				var sUPRC = document.getElementsByName("UPRC_" + iIndex)[0];
				if (useAllDatesForTotals !== "true") { //check whether to filter cart total calculations by date
					if (document.getElementsByName(sPROD + "_date")[0].value != date) return; // don't total up items for different date
				}
				var iQn = parseFloat(elem.value);
				if (isNaN(iQn)) iQn = 0;
				iQtyTotal += iQn;
				iCasesTotal += parseFloat(sCSEQ * iQn);	
				if (sUPRC) { // undefined when pricing turned off
					sUPRC = sUPRC.value.replace("$", "");
					var iAmnt = iQn * parseFloat(sUPRC);
					iAmntTotal += iAmnt;	
				}
				if (qField === elem) {
					if (PProCart.useServerSideRecalc()) {
						//send server side recalculation request. Needed for more advanced/special pricing situations.
						PProCart.serverSideAjaxRecalc(qField, date);
					} else {
						if (document.getElementById("amount_" + sPROD + "_" + date)) { // undefined when pricing turned off
							document.getElementById("amount_" + sPROD + "_" + date).innerHTML = "$" + iAmnt.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
						}
						
						// Build parameters for each quantity input field on the page
						if (!isNaN(parseFloat(elem.value))) {
							var ixIndex = elem.getAttribute("name").substring(5, 6);		
							var sxPROD = document.getElementsByName("PROD_" + ixIndex)[0].value;	
							var sxDate = document.getElementsByName(sxPROD + "_date")[0].value;
							parms += "&" + elem.getAttribute("name") + "=" + elem.value;
						}
					}
				}
			});
			PProAjax.get(
				"command=cartsubmit.ajax&ajax=y&function_update=y" + parms + "&axseqn=" + PProAjaxSequence.getNext(),
				null,
				null
			).then(() => {
				SystemPage.populateCartItems();
			});
		if (!isNaN(iQtyTotal) && !isNaN(iAmntTotal) && !isNaN(iCasesTotal)) {
			document.getElementById("itemcnt_" + date).innerHTML = iQtyTotal;
			document.getElementById("casecnt_" + date).innerHTML = PProCart.formatNumber(iCasesTotal);
			var fTotalAmnt = document.getElementById("totalamnt_" + date);
			if (fTotalAmnt) { // undefined when pricing turned off
				// Check that minimums are met
				if (!PProCart.useServerSideRecalc()) {
					// use client side recalc logic
					fTotalAmnt.innerHTML = PProCart.formatNumber(iAmntTotal);
					var iAmnt = document.getElementById("AMNTREQ").value - iAmntTotal;
					if (iAmnt <= 0) {
						iAmnt = 0;
						document.getElementById("minamnt_" + date).className = "";
					} else {
						document.getElementById("minamnt_" + date).className = "minnotmet";
					}
					document.getElementById("minamnt_" + date).innerHTML = PProCart.formatNumber(iAmnt);
				}

				var iMinQntyLeft;
				if (document.getElementById("USEQNTY").value == "Y") {
					iMinQntyLeft = document.getElementById("QNTYREQ").value - iQtyTotal;
				} else {
					iMinQntyLeft = document.getElementById("QNTYREQ").value - iCasesTotal;
				}
				if (iMinQntyLeft <= 0) {
					iMinQntyLeft = 0;
					document.getElementById("mincase_" + date).className = "";
				} else {
					document.getElementById("mincase_" + date).className = "minnotmet";
				}
				document.getElementById("mincase_" + date).innerHTML = PProCart.formatNumber(iMinQntyLeft);

				// Check that maximums are not exceeded
				var iMaxQntyLeft = document.getElementById("QNTYMAX").value - iCasesTotal;
				if (iMaxQntyLeft >= 0) {
					iMaxQntyLeft = 0;
					document.getElementById("maxcase_" + date).className = "";
				} else {
					iMaxQntyLeft *= -1;
					document.getElementById("maxcase_" + date).className = "maxnotmet";
				}
				document.getElementById("maxcase_" + date).innerHTML = PProCart.formatNumber(iMaxQntyLeft);
			}
		}
	},
	formatNumber: (val) => {
		return val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
	},
	cart_appendQuantityValues: (link) => {
		var sValue = "";
		document.querySelectorAll("input:not([type=hidden])").forEach((elem) => {
			if (!elem.hasAttribute("name") || !(elem.getAttribute("name").startsWith("QNTY_"))) return;
			var iIndex = elem.getAttribute("name").substring(5, 6);
			// Set Q_<LINENUM> to the proper quantity value
			sValue += "&Q_" + document.UIservletForm["LINENUM_" + iIndex].value + "=" + encodeURIComponent(document.UIservletForm[elem.getAttribute("name")].value);
		});
		link.setAttribute("href", link.getAttribute("href") + sValue);
	}
}
/* END Cart page functions */

/**
 * # PRODUCT FILTERS
 * This singleton contains all code support for live filtering and search.
 * Creates a global object `filters` (`window.filters`).
 * 
 * There are a number of component pieces that work together:
 *  - Event handlers hooked into the DOM for selecting and clearing a filter
 *  - Output on every product should be a list of what would match each filter
 *  - Using those to built an object of what filter options are selected and which products match those filters
 *  - Hide both items in the product list and items in the filter that no longer apply to the visible product set
 */

class ProductFilters {
	constructor(config) {
		this.config = config;
		this.attributes = {};
		this.keywords = "";
		this.FilterOptions = new Set();
		this.StartEventType = "filter:start";
		this.ClearEventType = "filter:clear";
		this.StartEvent = new Event(this.StartEventType);
		this.ClearEvent = new Event(this.ClearEventType);
	}

	/**
	 * Runs after DOMContentLoaded. Returns Promise that resolves when finished init
	 */
	init() {
		const doneLoading = new Promise((resolve, reject) => {
			window.addEventListener("DOMContentLoaded", () => {
				this.breakOutDropdowns();
				resolve();
			})
		});
		return doneLoading;
	}
	/**
	 * An object full of settings, mostly selectors. This allows for more flexible custom web designs.
	 */
	__conf(type, option, insert1) {
		var settings = {
			'general': {
				// returns elements which contain the filtering values for each product
				'product-list': '.catalogTable .attr_filter',
				// returns same as product-list, except only for currently visible products (aka they match the filters)
				'visible-product-list': '.catalogTable tr:not(.hidden) .attr_filter'
			},
			'category-dropdowns': {
				// returns the direct parent of all category input fields (in their final state, after they are broken out)
				'all-inputs': '.search-filter .search-filter-option',
				// returns the closest parent that contains all category dropdowns
				'group': '.filters .search-filter',
				// relative to group. returns the closest parent that contains all of a single category's dropdown values
				'old-input': 'select',
				// relative to old-input. returns all the individual option values for a single category
				'old-input-options': 'select > option',
				// New class name for the wrapper of an individual option
				'new-input-wrapper': 'search-filter-option',
				// New class name for the new input of that individual option
				'new-input-option': 'search-filter-option-value',
				// New class name of 
				'new-input-label': 'search-filter-option-text'
			},
			'filters': {
				// returns the closest parent(s) that contains all filters. Does not have to return a single element
				'group': '.filters',
				// returns all inputs for product attribute/attribute group filters
				'all-attribute-inputs': '.swc-group input[data-andor]',
				// returns all inputs for category (class/comm/brand/catg) filters
				'all-category-inputs': '[data-filter-for] input[data-andor]',
				// returns the class name of a parent element of 'attribute-value' that wraps the filter value for the attribute filter
				'attribute-group': 'filter',
				// give it the filter key. returns the element that identifies
				'attribute-value': 'input[name=fieldXREF][value=FILTER_'+insert1+']',
				// give it the filter key. returns the element that holds the filter value for a category
				'category-value': '[data-filter-for='+insert1+']'
			}
		};
		return settings[type][option]; 
	}
	doFilter() {
		var productList = document.querySelectorAll(this.__conf('general', 'product-list'));
		if (!productList) return;
		for (var p1 = 0; p1 < productList.length; p1++) {
			// Check for attributes. AND all categories together, choice to AND or OR attributes within a property
			var bAttributeFound = true;
			if (!PProUtil.IsEmptyObject(this.attributes)) {
				bAttributeFound = false;
				var thisProdAttributes = this.__attr(productList[p1].value);
				for (var prop in this.attributes) {
					if (thisProdAttributes.hasOwnProperty(prop)) {
						var bAnyAttributeMatches = false;
						var bAllAttributesMatch = false;
						for (var p4 = 0; p4 < thisProdAttributes[prop].attributes.length; p4++) {
							if (this.attributes[prop].attributes.indexOf(thisProdAttributes[prop].attributes[p4]) >= 0) {
								// OR mode. In this category, at least one attribute on this product matches the filter.
								bAnyAttributeMatches = true;
								// AND mode. In this category, all attributes on this product should match the filter
								bAllAttributesMatch = true;
							} else {
								bAllAttributesMatch = false;
							}
						}
						// Each product needs to match on each selected filter.
						if (this.attributes[prop].andOr === "O") {
							bAttributeFound = bAnyAttributeMatches;
							if (!bAttributeFound) break;
						} else if (this.attributes[prop].andOr === "A") {
							bAttributeFound = bAllAttributesMatch;
							if (!bAttributeFound) break;
						}
					} else {
						// Each product needs all selected categories present.
						bAttributeFound = false;
						break;
					}
				}
			}

			// Keyword search
			var bKeywordFound = true;
			if (this.keywords) {
				var spaceBetweenWords = /^\s+|\b[^\w]+/g; // match leading space and/or space between word boundaries
				var words = productList[p1].parentElement.parentElement.innerText.toLowerCase().replace(spaceBetweenWords, "");
				var keywords_split = this.keywords.split(spaceBetweenWords);
				for (var p7 = 0; p7 < keywords_split.length; p7++) {
					if (words.indexOf(keywords_split[p7]) === -1) {
						bKeywordFound = false;
					}
				}
			}

			// Show/hide logic. AND'ed together
			if (bAttributeFound && bKeywordFound) productList[p1].parentElement.parentElement.classList.remove("hidden");
			else productList[p1].parentElement.parentElement.classList.add("hidden");
		}
		// hide buttons except last one if there is a filter option selected
		const elemsToFireEvent = document.querySelectorAll('.profile-items .footer-buttons-table, .profile-items .commoditybreak');
		if (!PProUtil.IsEmptyObject(this.attributes) || this.keywords) {
			elemsToFireEvent.forEach((elem) => {
				if (elem.nodeName.toLowerCase() === "th") elem = elem.closest("tr"); // commodity break
				elem.dispatchEvent(this.StartEvent);
			});
		} else {
			elemsToFireEvent.forEach((elem) => {
				if (elem.nodeName.toLowerCase() === "th") elem = elem.closest("tr"); // commodity break
				elem.dispatchEvent(this.ClearEvent);
			});
		}
		this.disableIrrelevantFilters();
	}

	disableIrrelevantFilters() {
		var visibleProductList = document.querySelectorAll(this.__conf('general', 'visible-product-list'));
		// Map. Key is input name (e.g. ATTRFILTER_95), value is all the filtering options extracted
		var prodFilter = {};
		// Array of sets. Key is filtering key (e.g. _CLAS_, REGION, etc.). Values are filtering options available for 
		var used = [];

		// Loop through visible product list and break out Filter Options
		for (var i1 = 0; i1 < visibleProductList.length; i1++) {
			var currentFilterOptions = this.__attr(visibleProductList[i1].value);
			var filterOptionKeys = Object.keys(currentFilterOptions);

			// Loop through attributes
			for (var i2 = 0; i2 < filterOptionKeys.length; i2++) {
				// Sometimes the product list won't output the filter "key" on each product.
				// So we maintain a global list of available options
				if (!this.FilterOptions.has(filterOptionKeys[i2])) this.FilterOptions.add(filterOptionKeys[i2]);

				// For this filter option, add each option to the "used" set
				var thisFilterOption = currentFilterOptions[filterOptionKeys[i2]].attributes;
				if (!used[filterOptionKeys[i2]]) used[filterOptionKeys[i2]] = new Set();
				for (var i3 = 0; i3 < thisFilterOption.length; i3++) {
					used[filterOptionKeys[i2]].add(thisFilterOption[i3]);
				}
			}
			prodFilter[visibleProductList[i1].name] = currentFilterOptions;
		}

		// Add rest of unused options to "used" set with no entries
		for (const key of this.FilterOptions.keys()) {
			if (!used[key]) used[key] = new Set();
		}

		// Use the used set to disable filters. The filters are marked by either a data-filter-for attribute or an <input name=fieldXREF value=FILTER_YYY>
		document.querySelectorAll(
			this.__conf('filters', 'all-attribute-inputs') + ', ' +
			this.__conf('filters', 'all-category-inputs')
		).forEach((elem) => {
			elem.parentElement.classList.remove("filter-disable");
		});
		var usedKeys = Object.keys(used);
		for (var j1 = 0; j1 < usedKeys.length; j1++) {
			var thisFilter = document.querySelectorAll( this.__conf('filters', 'attribute-value', usedKeys[j1]) );
			if (thisFilter.length != 0) {
				// Traverse parents to find the attribute group element
				thisFilter = Array.from(thisFilter).map((elem) => {
					let currentElem = elem;
					while (currentElem.parentElement) {
						currentElem = currentElem.parentElement;
						if (currentElem.classList.contains(this.__conf('filters', 'attribute-group'))) {
							return currentElem;
						}
					}
				});
			} else {
				thisFilter = document.querySelectorAll( this.__conf('filters', 'category-value', usedKeys[j1]) );
			}
			if (thisFilter.length == 0) continue;

			for (const filter of thisFilter) {
				var filterItems = filter.querySelectorAll("input[data-andor]");
				for (var j2 = 0; j2 < filterItems.length; j2++) {
					if (!filterItems[j2].value) continue;
					if (!used[usedKeys[j1]].has(filterItems[j2].value)) {
						filterItems[j2].parentElement.classList.add('filter-disable')
					} else {
						filterItems[j2].parentElement.classList.remove('filter-disable')
					}
				}
			}
		}
	}
	/** 
	* Parse attributes. Input looks like of `ATTRIBUTE1{VALUE1_1{VALUE1_2|ATTRIBUTE2{VALUE2_1`
	* 
	* Return value looks like
	* ```json
	* {
	*   ATTRIBUTE1: {
	*     attributes: [ "VALUE1_1", "VALUE1_2" ]
	*   },
	*   ATTRIBUTE2: {
	*     attributes: [ "VALUE2_1" ] }
	*   }
	* }
	* ```
	*/
	__attr(sAttrTag) {
		var result = {};
		if (sAttrTag) {
			var tmpAttr = sAttrTag.split("|");
			if (tmpAttr) {
				for (var p5 = 0; p5 < tmpAttr.length; p5++) {
					var tmpAttrVals = tmpAttr[p5].split("{");
					if (tmpAttrVals && tmpAttrVals.length >= 2) {
						result[tmpAttrVals[0]] = {
							attributes: []
						};
						for (var p6 = 1; p6 < tmpAttrVals.length; p6++) {
							result[tmpAttrVals[0]].attributes.push(tmpAttrVals[p6]);
						}
					}
				}
			}
		}
		return result;
	}
	/* If it is possible that an option won't be in the product list, add them here. Attributes are like this */
	includeFilterOption(input) {
		var option = input.getAttribute("name").replace("FILTER_", "");
		this.FilterOptions.add(option);
	}
	/* Connect above "standardized" filtering to real DOM. */
	attributeGroupFilterCheckboxHandler(event) {
		var filterName = event.target.name.replace("FILTER_", "");
		var filterVal = event.target.value;
		var andOr = event.target.dataset.andor;
		this.attributeGroupFilter(filterName, filterVal, event.target.checked, andOr);
	}
	attributeGroupFilterRadioHandler(event) {
		var filterName = event.target.name.replace("FILTER_", "");
		var filterVal = event.target.value;
		var andOr = event.target.dataset.andor;
		delete this.attributes[filterName]; // radios only have one selection option
		this.attributeGroupFilter(filterName, filterVal, event.target.checked, andOr);
	}
	searchGroupFilterRadioHandler(event) {
		var filterName = event.target.name.replace("search-filter-option", "");
		var filterVal = event.target.value;
		var andOr = event.target.dataset.andor;
		delete this.attributes[filterName]; // radios only have one selection option
		this.attributeGroupFilter(filterName, filterVal, event.target.checked, andOr);
	}
	singleCheckboxHandler(event) {
		var filterName = event.target.name.replace("FILTER_", "");
		var filterVal = event.target.previousElementSibling.value;
		var andOr = event.target.dataset.andor;
		this.attributeGroupFilter(filterName, filterVal, event.target.checked, andOr);
	}
	/**
	* Takes the above filter sources, and updates the list of filters to search on.
	* @example
	* {
	*   NUTRITIONAL: {
	*     attributes: ["HALA", "KOSH", ...]
	*     andOr: "O"
	*   },
	*   STORAGE: {
	*     attributes: [...]
	*     andOr: "A"
	*   }
	* }
	*/
	attributeGroupFilter(sAttrType, sAttrValue, bOnOff, sAndOr) {
		if (sAttrValue) {
			if (!this.attributes[sAttrType]) this.attributes[sAttrType] = {
				attributes: [],
				andOr: sAndOr
			};
			if (bOnOff === false) {
				var idx = this.attributes[sAttrType].attributes.indexOf(sAttrValue);
				if (idx >= 0) this.attributes[sAttrType].attributes.splice(idx, 1);
				if (this.attributes[sAttrType].attributes.length === 0) {
					delete this.attributes[sAttrType];
				}
			} else {
				this.attributes[sAttrType].attributes.push(sAttrValue);
			}
		}
		this.doFilter();
	}
	/* Keyword filtering is separate as it searches the full text of each product row */
	keywordFilterHandler(event) {
		if (!event.target.value) {
			this.keywords = "";
			this.clearKeyword(event);
			this.doFilter();
		} else {
			this.keywordFilter(event.target.value.toLowerCase());
		}
	}
	keywordFilter(sKeyword) {
		this.keywords = sKeyword;
		this.doFilter();
	}
	clearKeyword(event) {
		event.target.value = "";
		this.keywords = "";
	}
	/* Event handlers for clearing filters out */
	clearFilters(event) {
		if (event && event.preventDefault) event.preventDefault();
		this.attributes = {};
		this.keywords = "";

		document.querySelectorAll(
			'.attribute-filter.filter-multi .swc-group-item,' +
			this.__conf('category-dropdowns', 'all-inputs') + ',' +
			'.keyword-filter,' +
			'.profile-items .footer-buttons-table'
		).forEach((elem) => {
			elem.dispatchEvent(this.ClearEvent);
		});
		document.querySelectorAll(
			'.profile-items .commoditybreak'
		).forEach((elem) => {
			elem.closest('tr').dispatchEvent(this.ClearEvent);
		});

		this.doFilter();
	}
	clearInput(event) {
		var inputToClear = event.target;
		if (event.target.nodeName.toLowerCase() !== "input") inputToClear = inputToClear.querySelector("input");
		if (inputToClear.type === "search") {
			inputToClear.value = "";
		} else {
			//console.log(inputToClear.value);
			if (inputToClear.value) inputToClear.checked = false;
			else inputToClear.checked = true;
		}
	}
	breakOutDropdowns() {
		document.querySelectorAll(this.__conf('category-dropdowns', 'group')).forEach((elem) => {
			var filterFor = elem.getAttribute('data-filter-for');
			var oldDropdown = elem.querySelector(this.__conf('category-dropdowns', 'old-input'));
			if (!oldDropdown) {
				elem.classList.add("hidden");
				return;
			}
			oldDropdown.classList.add('hidden');

			var newDropdownHtml = '';
			var oldDropdownOptions = elem.querySelectorAll(this.__conf('category-dropdowns', 'old-input-options'));
			if (oldDropdownOptions.length == 0 || 
					(oldDropdownOptions.length == 1 && oldDropdownOptions[0].value === '')) {
				// Empty dropdown
				elem.classList.add("hidden");
				return;
			}
			for (var i = 0; i < oldDropdownOptions.length; i++) {
				var optionValue = oldDropdownOptions[i].value;
				if (optionValue === '!!!!') optionValue = ''; // backward compatibility with commodity filter
				var optionText = oldDropdownOptions[i].innerHTML;
				if (optionText === "--Select--") optionText = "All";
				if (optionValue === '' && newDropdownHtml) continue; // If we already have a blank/default option, skip.
				var optionSelected = ((!optionValue) ? true : false);
				newDropdownHtml +=
					'<div class="form-check">' +
						'<label class="' + this.__conf('category-dropdowns', 'new-input-wrapper') + '" disabled="true">' + 
							'<input ' +
								'type="radio" ' +
								'name="' + this.__conf('category-dropdowns', 'new-input-wrapper') + filterFor + '" ' +
								'class="form-check-input ' + this.__conf('category-dropdowns', 'new-input-option') + '" value="' + optionValue + '" ' +
								(optionSelected ? 'checked' : '') + ' ' +
								'data-andor="O">' + 
							'<span class="' + this.__conf('category-dropdowns', 'new-input-label') + '">' + optionText + '</span>' +
						'</label>' +
                    '</div>';
			}
			elem.querySelector(".search-filter-header").innerHTML += newDropdownHtml;
		});
	}
}

// Initialize. Add event handlers to all clickable items within the filter.
// Prefer cusomizations by replicating the class structure in the html if possible.
const PProFilters = new ProductFilters();
PProFilters.init().then(() => {
	document.querySelectorAll('.attribute-filter.filter-multi .swc-radio')
		.forEach((elem) => {
			elem.addEventListener(PProFilters.ClearEventType, PProFilters.clearInput);
			const filterInput = elem.querySelector("input");
			filterInput.addEventListener("change", PProFilters.attributeGroupFilterRadioHandler.bind(PProFilters));
			PProFilters.includeFilterOption(filterInput);
		});

	document.querySelectorAll('.attribute-filter.filter-multi .swc-checkbox')
		.forEach((elem) => {
			elem.addEventListener(PProFilters.ClearEventType, PProFilters.clearInput);
			const filterInput = elem.querySelector("input");
			filterInput.addEventListener("click", PProFilters.attributeGroupFilterCheckboxHandler.bind(PProFilters));
			PProFilters.includeFilterOption(filterInput);
		});

	document.querySelectorAll('.attribute-filter.filter-single .filter-checkbox')
		.forEach((elem) => {
			elem.addEventListener(PProFilters.ClearEventType, PProFilters.clearInput);
			elem.querySelector("input[type=checkbox]").addEventListener("click", PProFilters.singleCheckboxHandler.bind(PProFilters));
		});

	document.querySelectorAll(PProFilters.__conf('category-dropdowns', 'all-inputs'))
		.forEach((elem) => {
			elem.addEventListener(PProFilters.ClearEventType, PProFilters.clearInput);
			elem.querySelector('input').addEventListener("change", PProFilters.searchGroupFilterRadioHandler.bind(PProFilters));
		});

	document.querySelectorAll('.keyword-filters .keyword-filter')
		.forEach((elem) => {		
			elem.addEventListener(PProFilters.ClearEventType, PProFilters.clearInput);
			elem.addEventListener("input", PProFilters.keywordFilterHandler.bind(PProFilters));
		});

	document.querySelectorAll('.profile-items .footer-buttons-table, .profile-items .commoditybreak')
		.forEach((elem) => {
			if (elem.nodeName.toLowerCase() === "th") elem = elem.closest("tr"); // commodity break
			elem.addEventListener(PProFilters.StartEventType, (event) => {
				event.target.classList.add("hidden");
			});
			elem.addEventListener(PProFilters.ClearEventType, (event) => {
				event.target.classList.remove("hidden");
			});
		});

	document.querySelector('.filters__clear')?.addEventListener("click", 
		PProFilters.clearFilters.bind(PProFilters)
	);

	PProFilters.doFilter()
});

/**
 * Automatically hook into Weglot translation functionality for core components of ecom
 */
const PProWeglot = {
	apiKey: null,
	initLoopIntervalId: null,
	translatedIFrame: {},
	callbacks: {},
	startup: function(settings) {
		this.apiKey = settings['api_key']
		Weglot.initialize({api_key: this.apiKey});
		Weglot.on("languageChanged", this.onLanguageChange);
		window.addEventListener("message", (event) => {
			console.log("new message: ", event, event.data);
			if (!event.data['iframe'] || !event.data['target'] || !event.data['content']) return;
			PProWeglot.newTranslateMessage(event.data['iframe'], event.data['target'], event.data['content']);
		}, false);
	},
	isEnabled: function() {
		return typeof Weglot === 'object';
	},
	init: function() {
		PProWeglot.initLoopIntervalId = setInterval(PProWeglot._initLoop, 500);
	},
	_initLoop: function() {
		console.log("[initLoop] Checking lang: ", Weglot.getCurrentLang());
		if (Weglot.getCurrentLang()) {
			clearInterval(PProWeglot.initLoopIntervalId);
			initLoopIntervalId = null;
			// startup tasks
			PProWeglot.onLanguageChange();
		}
	},
	newTranslateMessage: function(iframeId, elementName, content) {
		var element;
		try {
			element = document.getElementById(elementName);
		} catch(e) {
			if (document[elementName]) element = document[elementName];
		}
		element.innerHTML = content;
		this.translatedIFrame[iframeId].remove();
		delete this.translatedIFrame[iframeId];
		if (this.callbacks[iframeId]) {
			this.callbacks[iframeId]['callback'].apply();
			delete this.callbacks[iframeId];
		}
		if ($.isEmptyObject(this.translatedIFrame)) $('.loading').hide();
		PProWeglot.onLanguageChange();
	},
	onTranslateComplete: function(iframeId, callback_fn) {
		this.callbacks[iframeId] = {callback: callback_fn};
	},
	translateAjaxContent: function(elementName) {
		if (!PProWeglot.isEnabled()) return;
		var currentLang = Weglot.getCurrentLang();
		if (!currentLang || currentLang === 'en') return;
		if (!elementName) return;
		var element;
		try {
			element = document.getElementById(elementName);
		} catch(e) {
			if (document[elementName]) element = document[elementName];
		}
		if (!element) return;
		$('.loading').show();
		var iframeId = crypto.randomUUID();
		console.log("translateAjaxContent", iframeId, currentLang, element);
		this.translatedIFrame[iframeId] = document.createElement("iframe");
		this.translatedIFrame[iframeId].style = "visibility: hidden;";
		this.translatedIFrame[iframeId].src = 'data:text/html;base64,'
			+ btoa(element.innerHTML
			+ `<script src="https://cdn.weglot.com/weglot.min.js"></script>
				<script>
				Weglot.initialize({api_key: "${this.apiKey}",hide_switcher: true});
				Weglot.on("initialized", () => Weglot.switchTo("${currentLang}"));
				Weglot.on("languageChanged", () => {Array.from(document.getElementsByTagName("script")).forEach((elem) => elem.remove());
				window.top.postMessage({iframe: "${iframeId}", target:"${elementName}", content: document.body.innerHTML}, "*")});
				</script>`);
		document.body.append(this.translatedIFrame[iframeId]);
		return iframeId;
	},
	onLanguageChange: function() {
		setupProductFilters();
		if (document.querySelector(".ppc-page")) {
			var redirect = new URL(window.location.href);
			var lang = redirect.searchParams.get("LANG");
			if (!lang || lang.toLowerCase() !== Weglot.getCurrentLang()) {
				redirect.searchParams.set("LANG", Weglot.getCurrentLang().toUpperCase());
				window.location.href = redirect;
				return;
			}
		}
		if (document.querySelector(".ach-help")) {
			var achImg = document.querySelector(".ach-help");
			if (achImg.dataset[Weglot.getCurrentLang() + 'Src']) {
				achImg.setAttribute("src", achImg.dataset[Weglot.getCurrentLang() + 'Src']);
			}
		}
		if (document.querySelector(".ccident-link")) {
			var ccIdentHelp = document.querySelector(".ccident-link");
			if (ccIdentHelp.dataset[Weglot.getCurrentLang() + 'Href']) {
				ccIdentHelp.setAttribute("href", ccIdentHelp.dataset[Weglot.getCurrentLang() + 'Href']);
			}
		}
	},
	translateStrings: function(...words) {
		weglotWords = words.map((val) => {
			return {t: 1, w: val};
		});
		return Weglot.translate({ 'words': weglotWords });
	},
	// these can't be asynchronous
	YES: function() {
		var lang;
		if (!this.isEnabled()) lang = "en";
		else lang = Weglot.getCurrentLang();

		if (lang === 'fr') return "Oui";
		else return "Yes";
	},
	NO: function() {
		var lang;
		if (!this.isEnabled()) lang = "en";
		else lang = Weglot.getCurrentLang();

		if (lang === 'fr') return "Non";
		else return "No";
	},
	SUBSTITUTIONS: function() {
		var lang;
		if (!this.isEnabled()) lang = "en";
		else lang = Weglot.getCurrentLang();

		if (lang === 'fr') return "Substitutions"; // Yes its the same word
		else return "Substitutions";
	},
	CANCEL: function() {
		var lang;
		if (!this.isEnabled()) lang = "en";
		else lang = Weglot.getCurrentLang();

		if (lang === 'fr') return "Annuler";
		else return "Cancel";
	}
}
if (typeof $ !== 'undefined') {
	$( window ).on("load", function() {
		if (PProWeglot.isEnabled()) {
			PProWeglot.init();

			// Allow customizations per-customer
			if (typeof CustomWeglotHandler == "function") {
				window.CustomWeglotHandler = new CustomWeglotHandler();
			}
		}
	});
}

// Update subcustomer list after a ship to customer has been selected
function sendRefreshSubcustomerListRequest(subCustDiv, formname) {
	var shipToSelect = document.getElementById("SHIPTOLIST");
	var subCustSelect = document.getElementById("SUBCUST");
	
	if (shipToSelect.value.trim() == "") {
		//Create an empty select list
		var emptySelectList = document.createElement("select");
		emptySelectList.id = "SUBCUST";
		emptySelectList.disabled = true;;
		
		var option = document.createElement("option");
	    option.value = "--Select--";
	    option.text = "--Select--";
	    emptySelectList.appendChild(option);
		
		subCustSelect.parentNode.replaceChild(emptySelectList,subCustSelect);
	} else {
		PProAjax.submit("command=refreshSubcustomerSelection.ajax&formname=" + formname, subCustDiv, new Array('SHIPTOLIST','DLDT'));
	}
}

const PProReports = {
	initialize: () => {
		if (!PProUtil.CheckJsOnLoad("PProReports.initialize")) return;
		document.querySelectorAll(".report-submit").forEach((elem) => {
			elem.addEventListener("click", PProReports.submitRequest);
		});
		document.querySelector("[name=REPORT]")?.addEventListener("change", PProReports.onReportChanged);
		PProReports.checkAjaxContent();
		PProReports.setDownloadDisabled(document.UIservletForm["REPORT"].value);

	},
	onReportChanged: function(event) {
		try {
			PProReports.setDownloadDisabled(document.getElementById('REPORT').value); 
			PProAjax.submit("command=reporthandler.selectcriteriaajax", 'criteria.ajax', new Array('REPORT'), null, () => {
				PProReports.checkAjaxContent();
			});
		} catch(e) {
			PProDialog.alert('JavaScript Alert: Unable to make request for report criteria.');
		}
	},
	checkAjaxContent: function() {
		if (!$("#criteria\\.ajax").text().trim()) {
			$(".criteria-flavor").hide();
		} else {
			$(".criteria-flavor").show();
		}
	},
	submitRequest: () => {
		if (document.getElementById('RDLOAD') && document.getElementById('RDLOAD').checked) {
			// download requested
			PProReports.downloadSubmitted();
		} else {
			if (trim(document.getElementById('EMAIL').value) == "") {
				alertField(document.getElementById('EMAIL'), "Please enter a valid email address.");
				return; // email choice selected, but email blank
			}
		}
		document.UIservletForm.submit();
	},
	downloadSubmitted: () => {
		document.querySelector(".report-criteria").classList.add("hidden"); // Hide criteria
		let newContent = "<p>Your download request has been submitted.  Please standby...</p>"; 
		document.getElementById('contentdl5').innerHTML = newContent;		
		return true;
	},
	setDownloadDisabled: (sSelectedReport) => {
		var list = document.getElementById('report_dload_values');
		if (list != null && list.childNodes != null) {
			for (var i1 = 0; i1 < list.childNodes.length; i1++) {
				if (list.childNodes[i1].nodeName.toUpperCase() != "OPTION") continue;	
				if (list.childNodes[i1].value == sSelectedReport) {
					if (list.childNodes[i1].text == "Y") {
						document.getElementById('downloadRow').classList.remove("hidden");
					} else {
						document.getElementById('downloadRow').classList.add("hidden");
						document.getElementById('REMAIL').checked = true;
					}
					break;
				}
			}
		}
	}
};

export const OrderAddOn = {
	initialize: () => {
		OrderAddOn.warningSetup();
	},
	editSalesOrder: function(b, editSONO) {
		PProLoading.show();
		gaEditOrder();
		window.location = "command=orderaddon.modify&sono=" + editSONO + "&action=E";
	},
	warningSetup: () => {
		if (!PProUtil.CheckJsOnLoad("OrderAddOn.warningSetup")) return;
		// Edit order buttons will have the 'basic' class when there are items in the cart already
		const buttons = document.querySelectorAll("#addon-prompt .basic");
		buttons.forEach((b) => {
			b.addEventListener("click", function(e) {
				PProDialog.showModal(
					"Edit Order - Shopping Cart Warning",
					"<p>We just wanted to remind you that there are items in your shopping cart." +
					"If you choose to edit an order your current shopping cart will be emptied. </p>",
					new DialogButton("I'll continue to edit the order", () => {
						  // Buttons will have:  onclick="editSONO='03594869';"
				          // so we just eval() that to pass the sales order number
				          OrderAddOn.editSalesOrder(e.target, eval(e.target.getAttribute("onclick")));
					}),
					new DialogButton("I don't want to edit the order")
				);
			});
		});		
	}
};

export const PProBatchAds = {
	totalsUpdate: (sValue, sRow, sCol) => {
		let dRowTotal = 0;
		let dColTotal = 0;
		let dTmpTotal = 0;
		aTotals[sRow][sCol] = sValue;
	
		for (let i1 = 0; i1 < aTotals[sRow].length; i1++) {
			if (aTotals[sRow][i1] == null) {
				const fField = document.getElementById('INP' + sRow + i1);
				if (fField != null) {
					aTotals[sRow][i1] = fField.value;
				} else {
					continue;
				}
			}
			dTmpTotal = parseFloat(aTotals[sRow][i1]);
			if (isNaN(dTmpTotal))
				dTmpTotal = 0;
			dRowTotal += dTmpTotal;
		}
		if (document.getElementById('RTOT' + sRow) != null) {
			document.getElementById('RTOT' + sRow).innerHTML = dRowTotal;
		}
		for (let i1 = 0; i1 < aTotals.length; i1++) {
			if (aTotals[i1][sCol] == null) {
				const fField = document.getElementById('INP' + i1 + sCol);
				if (fField != null) {
					aTotals[i1][sCol] = fField.value;
				} else {
					continue;
				}
			}
			dTmpTotal = parseFloat(aTotals[i1][sCol]);
			if (isNaN(dTmpTotal))
				dTmpTotal = 0;
			dColTotal += dTmpTotal;
		}
		if (document.getElementById('CTOT' + sCol) != null) {
			document.getElementById('CTOT' + sCol).innerHTML = dColTotal;
		}
	},

	adOrderSubmit: () => {
		if (!Ecom2.PProBatchAds.validateCartFormAdBased())
			return false;
		const aInputFields = new Array();
		// Hide submit buttons
		document.getElementById('buttons_subh').style.display = 'none';
		document.getElementById('buttons_subf').style.display = 'none';
		// Disable quantity input fields
		let i3 = 0;
		for (let i1 = 0; i1 < aTotals.length; i1++) {
			for (let i2 = 0; i2 < aTotals[i1].length; i2++) {
				const inpField = document.getElementById('INP' + i1 + '' + i2);
				if (inpField != null) {
					aInputFields[i3] = inpField.name;
					inpField.disabled = true;
					i3++;
				}
			}
		}
		// Submit order
		Ecom2.PProAjax
			.submit('command=adbasedordersub.ajax&function_checkout=y', 'div_sub', aInputFields)
			.then(() => {
				// Convert input fields to text fields
				for (let i1 = 0; i1 < aTotals.length; i1++) {
					for (let i2 = 0; i2 < aTotals[i1].length; i2++) {
						const inpField = document.getElementById('INP' + i1 + '' + i2);
						if (inpField != null)
							Ecom2.PProBatchAds.changeInputToText(inpField, 'text');
					}
				}
				// Display success or failure message based on ajax results
				const json = JSON.parse(document.getElementById('div_sub').innerHTML);
				Ecom2.PProBatchAds.orderSubmitted(json.success, json.logout);
			});
		return true;
	},

	changeInputToText: (oldObject, oType) => {
		const newObject = document.createElement('span');
		newObject.type = oType;
		if (oldObject.value) newObject.innerHTML = oldObject.value;
		if (oldObject.name) newObject.name = oldObject.name;
		if (oldObject.id) newObject.id = oldObject.id;
		if (oldObject.className) newObject.className = oldObject.className;
		oldObject.parentNode.replaceChild(newObject, oldObject);
	},

	orderSubmitted: (bSuccess, bPromptToExit) => {
		// Show print button
		Ecom2.PProLoading.hide();
		document.getElementById('buttons_print').style.display = 'block';
		document.getElementById('instructions').style.display = 'none';
		document.getElementById('title').innerHTML = "Order Recap";
		if (bSuccess) {
			document.getElementById('tablecon_top').innerHTML = "<h3>Your order was successful. Please print this page for your records.</h3>";
		} else {
			document.getElementById('tablecon_top').innerHTML = "<h3><font color=\"#c30\">WARNING: Please call to confirm your order.<font></h3>";
		}
		if (bPromptToExit !== undefined && bPromptToExit == true) {
			Ecom2.PProDialog.alert("Your order is complete. Press 'OK' to sign out.", null, () => Ecom2.SystemPage.doLogout());
		}
	},

	validateCartFormAdBased: () => {
		for (let i1 = 0; i1 < aTotals.length; i1++) {
			for (let i2 = 0; i2 < aTotals[i1].length; i2++) {
				const inpField = document.getElementById('INP' + i1 + '' + i2);
				if (inpField != null && !Ecom2.validateQuantity(inpField, null, null, null, null, null, null)) {
					return false;
				}
			}
		}
		return true
	},
};

export const PProSRP = {
	SRPTooltipSetup: () => {
		var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'))
		var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
			return new Tooltip(tooltipTriggerEl, {
				html: true
			});
		})
	},

	clearAll: () => {
		document.UIservletForm["ALL_CB"].checked = false;
	},

	clearClasses: () => {
		const categories = document.querySelector(".srpFilterOption");
		categories.querySelectorAll(".form-check-input").forEach(function(checkbox){
			checkbox.checked = false;
		});
	},

	checkRowModified: (lnct, pdno) => {
		const qtyDiff = document.getElementById("oldQ"+pdno).textContent != document.getElementById("NEWQ"+pdno).value;
		const prcDiff = document.getElementById("oldPRC"+pdno).textContent != document.getElementById("NEWPRC"+pdno).value;
		const gpDiff = document.getElementById("oldGP"+pdno).textContent != document.getElementById("NEWGP"+pdno).value;
		
		const productRows = document.getElementsByClassName("row_"+lnct);
		for (let i = 0; i < productRows.length ; i++) {
			const row = productRows[i];
			if (qtyDiff || prcDiff || gpDiff) {
				row.classList.add("SRPmodified");
			} else {
				row.classList.remove("SRPmodified");
			}
		}
	},
	submitForm: (skipLoadCheck) => {
		if (typeof skipLoadCheck !== "boolean") skipLoadCheck = false;
		if (processing == true) {
			PProDialog.alert(pageLoadingMsg);
			return;
		}
		// If page took 60 seconds or longer to load, confirm the user wants to leave the page (as it will take them a long time to get back)
		if (!skipLoadCheck && performance.timing && (performance.timing.domComplete - performance.timing.navigationStart > 60000)) {
			PProDialog.showModal(
				"Continue with SRP updates??",
				"This page took a long time to load. Continue with SRP updates??",
				new DialogButton("Yes", () => {
					Ecom2.PProSRP.submitForm(true);
				}),
				new DialogButton("No")
			);
			return;
		}
		if (document.UIservletForm["nextCommand"]){
			document.UIservletForm["nextCommand"].value="";
		}
		// Add ajax sequence number
		if (document.UIservletForm["axseqn"]) {
			document.UIservletForm["axseqn"].value = PProAjaxSequence.getNext();
		}
		PProAjax.abortAll();
		document.UIservletForm.submit();
	}
};

let mapLibraryLoaded = false;
export const WheresMyTruck = {
	initialize: (licensekey) => {
		if (!mapLibraryLoaded) {
			(g => {var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
			    key: licensekey,
			    v: "weekly",
			    // Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
			    // Add other bootstrap parameters as needed, using camel case.
			});
			mapLibraryLoaded = true;
		}
	},
	initMap: async function(mykey, mylat, mylong, myimg) {
		WheresMyTruck.initialize(mykey);
		const { Map } = await google.maps.importLibrary("maps");
		let myLatLng = {
			lat: parseFloat(mylat),
			lng: parseFloat(mylong)
		};
		let map = new Map(document.getElementById("map"), {
			center: myLatLng,
			zoom: 12,
		});
		let marker = new google.maps.Marker({
			position: myLatLng,
			map: map,
			icon: myimg,
			title: 'Truck Location'
		});
		marker.addListener('click', () => {
			if (marker.getAnimation() !== null) marker.setAnimation(null);
			else marker.setAnimation(google.maps.Animation.BOUNCE);
		});
	}
}

export const PProProfile = {
	resizeTriggered: false,
	initialize: () => {
		if (!PProUtil.CheckJsOnLoad("PProProfile.profilePageSetup")) return;
		PProProfile.infoBannerSetup();
		PProProfile.footerFilterSetup();
		PProProfile.gridListButtonSetup();
		PProProfile.showGuideLinesPopup();
	},
	infoBannerSetup: () => {
		// Populate order info.  Delivery date, warehouse, subcustomer, profile tag
		if (document.getElementById("banordfor") !== null) {
			if (document.getElementById("banwhse").innerHTML.trim() !== "") {
				document.getElementById("banwhse").parentElement.classList.add("before@lg");
				document.getElementById("banwhse").parentElement.classList.add("before--separator");
			}
			if (document.getElementById("region_orderingfor").innerHTML.trim() !== "") {
				document.getElementById("banordfor").parentElement.classList.add("before@lg");
				document.getElementById("banordfor").parentElement.classList.add("before--separator");
				document.getElementById("banordfor").innerHTML = document.getElementById("region_orderingfor").innerHTML;
				document.getElementById("banordfortxt").innerHTML = "Ordering For:";
			}
			if (document.getElementById("region_subcustomer").innerHTML.trim() !== "") {
				document.getElementById("bansubcus").parentElement.classList.add("before@lg");
				document.getElementById("bansubcus").parentElement.classList.add("before--separator");
				document.getElementById("bansubcus").innerHTML = document.getElementById("region_subcustomer").innerHTML;
				document.getElementById("bansubcustxt").innerHTML = "Subcustomer:";
			}
			if (document.getElementById("region_profiletag").getElementsByTagName("div")[0].innerHTML.trim() !== "") {
				document.getElementById("banproftag").parentElement.classList.add("before@lg");
				document.getElementById("banproftag").parentElement.classList.add("before--separator");
				document.getElementById("banproftag").innerHTML = document.getElementById("region_profiletag").getElementsByTagName("div")[1].innerHTML;
				document.getElementById("banproftagtxt").innerHTML = document.getElementById("region_profiletag").getElementsByTagName("div")[0].innerHTML + ":";
			}
		}
	},
	showGuideLinesPopup: () => {
		const lastGuidelinesDialogTime = localStorage.getItem('ecom_LastGuidelinesDialogTime');
		const oneWeekAgo = new Date().getTime() - 604800000; // 7 days in milliseconds
		if (!lastGuidelinesDialogTime || lastGuidelinesDialogTime < oneWeekAgo) {
			// Update local storage
			localStorage.setItem('ecom_LastGuidelinesDialogTime', new Date().getTime());
			// Show Guidelines
			var s1 = document.getElementById("orderingGuidelinesWrapper").innerHTML;
			// remove collapse style
			s1 = s1.replaceAll(" collapse", ""); 
			// change icons
			s1 = s1.replaceAll(".png", "_gray.png");
			s1 = s1.replace("clock_gray.png", "clock_red.png");
			PProDialog.showModal("", s1, new DialogButton("OK"));
		}
	},
	gridListButtonSetup: () => {
		// Make toggle buttons work
		const viewTriggers = document.querySelectorAll(".order__view-trigger");
		const orderContent = document.getElementById("order_content");
		const orderView = document.getElementById("order_view");
		let viewTimeout;
		for (let i = 0; i < viewTriggers.length; i++) {
			viewTriggers[i].addEventListener( "click", (e) => {
				e.preventDefault();
				if (e.currentTarget.classList.contains("active")) return null;
				const view = e.currentTarget.getAttribute("data-view");
				const mobile = e.currentTarget.getAttribute("data-mobile");
				const oldEls = document.querySelectorAll(".order__view-trigger.active");
				for (let j = 0; j < oldEls.length; j++) {
					oldEls[j].classList.remove('active');
				}
				var altSelector = ".order__view-trigger[data-view='" + view + "']";
				altSelector += ( mobile === "0" ? "[data-mobile='1']" : "[data-mobile='0']" );
				const altEl = document.querySelector(altSelector);
				if (altEl) altEl.classList.add("active");
				e.currentTarget.classList.add("active");
				orderView.style.opacity = 0;
				clearTimeout(viewTimeout);
				viewTimeout = setTimeout(() => {
					orderContent.setAttribute("data-view", view);
					orderView.style.opacity = 1;
				}, 400);
			});
		}
		// Responsive. When going under a certain size, trigger grid view
		const clickGridViewInMobile = () => {
			if (!PProProfile.resizeTriggered && window.innerWidth < 768) {
				PProProfile.resizeTriggered = true;
				document.querySelector(".order__view-trigger[data-view=grid]").click();
				// hide the grid/list view toggle
				if (document.getElementById('mobile-view-trigger')) {
					document.getElementById('mobile-view-trigger').classList.add("hidden");
				}
			} else {
				PProProfile.resizeTriggered = false;
				// show the grid/list view toggle
				if (document.getElementById('mobile-view-trigger')) {
					document.getElementById('mobile-view-trigger').classList.remove("hidden");
				}
			}
		}
		clickGridViewInMobile();
		window.addEventListener("resize", clickGridViewInMobile);
	},
	footerFilterSetup: () => {
		const bUsingCommodityFilter = document.querySelector("#dual_commodity")?.classList.contains("advsearch-commodity");
		const bUsingClassFilter = document.querySelector("#dual_class")?.classList.contains("advsearch-class");
		const bUsingBrandFilter = document.querySelector("#dual_brand")?.classList.contains("advsearch-brand");
		// Move search stuff to the left side filter
		var filterContent = document.querySelector("#footer_searchFilter").innerHTML;
		document.querySelector("#footer_searchFilter").remove();
		if (document.querySelector("#header_liveSearchFilter")) {
			document.querySelector("#header_liveSearchFilter").replaceWith(PProUtil.nodeFromHTML(filterContent));
		}
		var searchRegion = document.querySelector("#footer_searchRegion");
		document.querySelector("#footer_searchRegion").remove();

		const attributeFilterDiv = document.querySelector("#footer_attributeFilter");
		if (attributeFilterDiv !== null) {
			// Move attribute filters to header
			document.querySelector("#footer_attributeFilter").remove();
			if (document.querySelector("#header_attributeFilter")) {
				document.querySelector("#header_attributeFilter").replaceWith(PProUtil.nodeFromHTML(attributeFilterDiv.innerHTML));
			}
		}

		if (bUsingCommodityFilter) PProAjax.submit("command=populatecommlist.ajax", 'catalog_commodity_region');
		if (bUsingClassFilter) PProAjax.submit("command=populateclasslist.ajax", 'catalog_class_region');
		if (bUsingBrandFilter) PProAjax.submit("command=populatebrandlist.ajax", 'catalog_brand_region');

		// Build Advanced Search Area in Header
		// On pages with the advanced search options div, move various content into the header dropdown area
		const dAdvSearch = document.getElementById('advanced__search');
		if (dAdvSearch) {
			// Add copy of filter dropdowns to the header adv search div
			document.querySelector("#header_advSearch_dropdowns").innerHTML = searchRegion.innerHTML;
			// Move advanced search content from profile page div to system page div
			const ddContent = document.querySelector("#ordering_dropdown_content");
			ddContent.replaceChildren(PProUtil.nodeFromHTML("<div class=\"row\">" + dAdvSearch.innerHTML + "</div>"));
			dAdvSearch.remove(); // remove from DOM
		
			document.querySelectorAll("#SearchText").forEach((d) => {
				d.addEventListener('click', () => {
					// Show/hide the dropdown when the input is clicked
					document.getElementById('ordering_dropdown').classList.toggle('show');
				});
			});
		}
	},	
	setFormFocus: function(targetName) {
		if (document.UIservletForm[targetName]) {
			document.UIservletForm[targetName].focus();
			document.UIservletForm[targetName].select();
			return true;
		} else {
			return false;
		}
	},
	toggleSecondaryItems: function() {
		var rows = document.getElementsByClassName("secondaryItemClass");
		var i;
		var row;
		var classes;
		for (i = 0; i < rows.length; i++){
			row = rows[i];
			classes = row.className.split(" ");
			if (classes[classes.length-1] === "hidden") {
				classes.pop();
				row.className = classes.join(" ");
			} else {
				row.className += " hidden";
			}
		}
	},
	profMaintSubmit: function() {
		document.UIservletForm["parm"].value="";
		document.UIservletForm["nextCommand"].value="ProfileMaintenanceHandler.initreact";
		document.UIservletForm["name"].value="";
		PProLoading.show();
		document.UIservletForm.submit();
	},	
	crosssell: function(sDesc) {
	    if (processing == true) {
	            PProDialog.alert(pageLoadingMsg);
	            return false;
	    }
	    document.UIservletForm["parm"].value= "nothing";
	    document.UIservletForm["DESC"].value= sDesc;
	    document.UIservletForm["nextCommand"].value="crosssell";
	    document.UIservletForm["name"].value="profile";
	    try {
	            document.UIservletForm["PAGE"].value="0";
	    } catch(e) { }
	    PProLoading.show();
	    document.UIservletForm.submit();
	    return false;
	},
	submitCatalogForm: function() {
		if (document.UIservletForm["nextCommand"]) {
			document.UIservletForm["parm"].value="nothing";
			document.UIservletForm["nextCommand"].value="catalogpage";
			document.UIservletForm["name"].value="profile";
		}
		PProLoading.show();
		document.UIservletForm.submit();
	},
	validateInventoryQuantity: function(field, quantity) {
		if (quantity === "" || !isNaN(quantity)) {
			if (quantity < 0) {
				PProDialog.alert("Warning! You entered a negative inventory number.");
				return false;
			}
			return true;
		} 
		PProDialog.alert("Warning! You entered an invalid quantity. Your input will be erased.");
		field.value = "";
		field.focus();
		return false;
	},
	changeProfileTag: function() {
		/* profile tag switching support */
		document.UIservletForm["parm"].value="nothing";
		document.UIservletForm["nextCommand"].value="changeprofiletag";
		document.UIservletForm["name"].value="profile";
		PProLoading.show();
		document.UIservletForm.submit();
	},
	searchUsingFilter: () => {
		if (processing == true) {
			PProDialog.alert(pageLoadingMsg);
			return;
		}
		document.UIservletForm["parm"].value= "nothing";
		document.UIservletForm["nextCommand"].value="productsearchsubmit";
		document.UIservletForm["name"].value="profile";
		document.getElementById("SearchText").value="";
		try {
			document.UIservletForm["PAGE"].value="0";
		} catch(e) { }
		PProLoading.show();
		document.UIservletForm.submit();
	},
	changeDualSearch: function() {
		var dualCommodity = document.getElementById("dual_commodity")
		var dualClass = document.getElementById("dual_class");
		var dualBrand = document.getElementById("dual_brand");
		var searchSelect = document.getElementById("SELECTSEARCH");
		var selectedOpt = searchSelect.options[searchSelect.selectedIndex].value;
		
		if (selectedOpt == "commodity") {
			dualCommodity.classList.remove("hidden");
			dualClass.classList.add("hidden");
			try { document.getElementById('CLASSSEARCH').selectedIndex = 0; } catch(e) { }
			dualBrand.classList.add("hidden");
			try { document.getElementById('BRANDSEARCH').selectedIndex = 0; } catch(e) { }
		} else if (selectedOpt == "class") {
			dualClass.classList.remove("hidden");
			dualCommodity.classList.add("hidden");
			try { document.getElementById('COMMSEARCH').selectedIndex = 0; } catch(e) { }
			dualBrand.classList.add("hidden");
			try { document.getElementById('BRANDSEARCH').selectedIndex = 0; } catch(e) { }
		} else if (selectedOpt == "brand") {
			dualBrand.classList.remove("hidden");
			dualClass.classList.add("hidden");
			try { document.getElementById('CLASSSEARCH').selectedIndex = 0; } catch(e) { }
			dualCommodity.classList.add("hidden");
			try { document.getElementById('COMMSEARCH').selectedIndex = 0; } catch(e) { }
		}
	},
	commoditySearchChange: function() {
		if (document.querySelector('#catalogready').value == "false") {
			// check to see if catalog retrieval is complete
			PProAjax
				.submit("command=commlistready.ajax", 'catalog_commodity_ready')
				.then(PProProfile.commoditySearchChange)
			document.querySelector('#commselect1').checked = true;
			document.querySelector('#commselect2').checked = false;
			PProDialog.alert("Your searchable catalog is being built, please try again in 30 seconds.");
			return;
		}
		/***************************************************************************************
		 * PM_COMMODITY_ONCHANGE_PARM is a form field that can be populated with an override to
		 * the default JavaScript function that gets executed onChange of the commmodity 
		 * drop-down list.
		 */
		if (document.querySelector('#catalog_commodity_region').childNodes == null ||
					document.querySelector('#catalog_commodity_region').childNodes.length == 0) {
			// Trigger request that builds catalog commodity list
			if (document.querySelector('#COMMSELECTED') != null) {
				PProAjax
					.submit("command=populatecommlist.ajax&COMMSELECTED=" + document.querySelector('#COMMSELECTED').value, 'catalog_commodity_region',[PM_COMMODITY_ONCHANGE_PARM])
					.then(PProProfile.commoditySearchChange);
				return;
			} else {
				PProAjax
					.submit("command=populatecommlist.ajax", 'catalog_commodity_region',[PM_COMMODITY_ONCHANGE_PARM])
					.then(PProProfile.commoditySearchChange);
				return;
			}
		}
	
		// We've loaded all the commodity data, continue
		if (document.querySelector('#commselect2').checked) {
			document.querySelector('#profile_commodity_region').style.display = "none";
			document.querySelector('#catalog_commodity_region').style.display = "inline";
		} else {
			if (document.UIservletForm["nextCommand"] != null && document.UIservletForm["nextCommand"].value == "catalogpage") {
				// We enter this code when on the catalog page
				var eSelProfProd = document.querySelector('#COMMSEARCH');
				if (eSelProfProd != null) {		
					// Add --select-- option to profile filter dropdown 
					if (eSelProfProd.options[0].text != "--Select--") {
						// Insert select option if it's not there already
						try {
							// standards compliant, doesn't work in IE
							eSelProfProd.add(new Option('--Select--', '', true, true), eSelProfProd.options[0]);
					    }
					    catch(ex) {
							eSelProfProd.add(new Option('--Select--', '', true, true), 0); // IE only
					    }
					}
				}
			} 
			document.querySelector('#profile_commodity_region').style.display = "inline";
			document.querySelector('#catalog_commodity_region').style.display = "none";
		} 
	},
	brandSearchChange: function() {
		if (document.getElementById('catalog_brand_region').childNodes == null ||
					document.getElementById('catalog_brand_region').childNodes.length == 0) {
			// Trigger request that builds catalog brand list
			if (document.getElementById('BRANDSELECTED') != null) {
				PProAjax
					.submit("command=populatebrandlist.ajax&BRANDSELECTED=" + document.getElementById('BRANDSELECTED').value, 'catalog_brand_region',[PM_BRAND_ONCHANGE_PARM])
					.then(PProProfile.brandSearchChange);
				return;
			} else {
				PProAjax
					.submit("command=populatebrandlist.ajax", 'catalog_brand_region', [PM_COMMODITY_ONCHANGE_PARM])
					.then(PProProfile.brandSearchChange);
				return;
			}
		}
		if (document.getElementById('brandselect2').checked) {
			document.getElementById('profile_brand_region').style.display = "none";
			document.getElementById('catalog_brand_region').style.display = "inline";
		} else {
			if (document.UIservletForm["nextCommand"] != null && document.UIservletForm["nextCommand"].value == "catalogpage") {
				// We enter this code when on the catalog page
				var eSelProfProd = document.getElementById('BRANDSEARCH');
				if (eSelProfProd != null) {		
					// Add --select-- option to profile filter dropdown 
					if (eSelProfProd.options[0].text != "--Select--") {
						// Insert select option if it's not there already
						try {
							// standards compliant, doesn't work in IE
							eSelProfProd.add(new Option('--Select--', '', true, true), eSelProfProd.options[0]);
					    }
					    catch(ex) {
							eSelProfProd.add(new Option('--Select--', '', true, true), 0); // IE only
					    }
					}
				}
			} 
			document.getElementById('profile_brand_region').style.display = "inline";
			document.getElementById('catalog_brand_region').style.display = "none";
		} 
	},
	classSearchChange: function() {
		if (document.getElementById('profile_class_region').childNodes == null ||
					document.getElementById('profile_class_region').childNodes.length == 0) {
			// Trigger request that builds profile class list
			if (document.getElementById('CLASSSELECTED') != null) {
				PProAjax
					.submit("command=populateclasslist.ajax&CLASSSELECTED=" + document.getElementById('CLASSSELECTED').value, 'profile_class_region',[PM_CLASS_ONCHANGE_PARM])
					.then(PProProfile.classSearchChange);
				return;
			} else {
				PProAjax
					.submit("command=populateclasslist.ajax", 'profile_class_region', [PM_CLASS_ONCHANGE_PARM])
					.then(PProProfile.classSearchChange);
				return;
			}
		}
		if (document.getElementById('classselect2').checked) {
			document.getElementById('profile_class_region').style.display = "none";
			document.getElementById('catalog_class_region').style.display = "inline";
		} else {
			if (document.UIservletForm["nextCommand"] != null && document.UIservletForm["nextCommand"].value == "catalogpage") {
				// We enter this code when on the catalog page
				var eSelProfProd = document.getElementById('CLASSSEARCH');
				if (eSelProfProd != null) {
					// Add --select-- option to profile filter dropdown
					if (eSelProfProd.options[0].text != "--Select--") {
						// Insert select option if it's not there already
						try {
							// standards compliant, doesn't work in IE
							eSelProfProd.add(new Option('--Select--', '', true, true), eSelProfProd.options[0]);
					    }
					    catch(ex) {
							eSelProfProd.add(new Option('--Select--', '', true, true), 0); // IE only
					    }
					}
				}
			}
			document.getElementById('profile_class_region').style.display = "inline";
			document.getElementById('catalog_class_region').style.display = "none";
		}
	},
	relatedunits: (event, sDesc) => {
		event.stopPropagation();
		if (processing == true) {
			PProDialog.alert(pageLoadingMsg);
			return false;
		}
		document.UIservletForm["parm"].value= "nothing";
		document.UIservletForm["DESC"].value= sDesc;
		document.UIservletForm["nextCommand"].value="productunits";
		document.UIservletForm["name"].value="profile";
		try {
			document.UIservletForm["PAGE"].value="0";
		} catch(e) { }
		PProLoading.show();
		document.UIservletForm.submit();
	},
	suggesteditems: (event, sDesc) => {
		event.stopPropagation();
		if (processing == true) {
			PProDialog.alert(pageLoadingMsg);
			return false;
		}
		document.UIservletForm["parm"].value= "nothing";
		document.UIservletForm["DESC"].value= sDesc;
		document.UIservletForm["nextCommand"].value="productssuggested";
		document.UIservletForm["name"].value="profile";
		try {
			document.UIservletForm["PAGE"].value="0";
		} catch(e) { }
		PProLoading.show();
		document.UIservletForm.submit();
	},
	substituteitems: (event, sDesc) => {
		event.stopPropagation();
		if (processing == true) {
			PProDialog.alert(pageLoadingMsg);
			return false;
		}
		document.UIservletForm["parm"].value= "nothing";
		document.UIservletForm["DESC"].value= sDesc;
		document.UIservletForm["nextCommand"].value="productssubstitute";
		document.UIservletForm["name"].value="profile";
		try {
			document.UIservletForm["PAGE"].value="0";
		} catch(e) { }
		PProLoading.show();
		document.UIservletForm.submit();
	},
	commsearch: function() {
		var sCommodity = document.getElementById('profile_comm_values').value;
		if (trim(sCommodity) == "") return;
		document.UIservletForm["DESC"].value= sCommodity;
		document.UIservletForm["COMM"].value= sCommodity;
		document.UIservletForm["CLASS"].value= "";
		document.UIservletForm["BRAND"].value= "";
		PProProfile.searchUsingFilter();
	},
	classsearch: function() {
		var sClass = document.getElementById('profile_class_values').value;
		if (trim(sClass) == "") return;
		document.UIservletForm["DESC"].value= sClass;
		document.UIservletForm["COMM"].value = ""
		document.UIservletForm["CLASS"].value= sClass;
		document.UIservletForm["BRAND"].value= "";
		PProProfile.searchUsingFilter();
	},
	brandsearch: function() {
		var sBrand = document.getElementById('profile_brand_values').value;
		if (trim(sBrand) == "") return;
		document.UIservletForm["DESC"].value= sBrand;
		document.UIservletForm["COMM"].value= "";
		document.UIservletForm["CLASS"].value= "";
		document.UIservletForm["BRAND"].value= sBrand;
		PProProfile.searchUsingFilter();
	},
	allLocalSearch: function() {
		try { document.UIservletForm["profile_comm_values"].value = ""; } catch(e) { }
		try { document.UIservletForm["CLASSSEARCH"].value = ""; } catch (e) { } 
		try { document.UIservletForm["CLASS"].value = ""; } catch(e) { } 
		try { document.UIservletForm["PAGE"].value = "0"; } catch(e) { }
		try { document.UIservletForm["COMM"].value = ""; } catch(e) { }
		try { document.UIservletForm["BRAND"].value= ""; } catch(e) { }
		try { document.UIservletForm["ORGANIC"].checked = false; } catch(e) { }
		document.UIservletForm["parm"].value = "nothing";
		document.UIservletForm["nextCommand"].value = "productsearchsubmit";
		document.UIservletForm["name"].value = "profile";
		document.getElementById("SearchText").value = "";
		document.UIservletForm["DESC"].value = "*|LOCAL|*";
		PProLoading.show();
		document.UIservletForm.submit();
	},
	allOrganicSearch: function() {
		try { document.UIservletForm["profile_comm_values"].value = ""; } catch(e) { }
		try { document.UIservletForm["CLASSSEARCH"].value = ""; } catch (e) { } 
		try { document.UIservletForm["CLASS"].value = ""; } catch(e) { } 
		try { document.UIservletForm["PAGE"].value = "0"; } catch(e) { }
		try { document.UIservletForm["COMM"].value = ""; } catch(e) { }
		try { document.UIservletForm["BRAND"].value= ""; } catch(e) { }
		try { document.UIservletForm["LOCAL"].checked = false; } catch(e) { }
		document.UIservletForm["parm"].value = "nothing";
		document.UIservletForm["nextCommand"].value = "productsearchsubmit";
		document.UIservletForm["name"].value = "profile";
		document.getElementById("SearchText").value = "";
		document.UIservletForm["DESC"].value = "*|ORGANIC|*";
		PProLoading.show();
		document.UIservletForm.submit();
	},
	displayGrossSales: function(mult, srp, qty, displayTarget, pkct) {
		var grossSales=0;
		try {
			grossSales = ((pkct/mult)*qty)*srp;
		} catch(e) {
			document.getElementById(displayTarget).innerHTML = "";	
		}
		document.getElementById(displayTarget).innerHTML = formatCurrency(grossSales);
		PProProfile.calculateGrossSalesTotals();
	},
	calculateGrossSalesTotals: function() {
		if (!calculateGrossSales) return;
		// Update totals
		var grossSalesTotal = 0.00;
		var itemCountTotal = 0.00;
		var orderTotal = 0.00;
		document.querySelectorAll('input[type="TEXT"]').forEach((elem) => {
	         elem;
	         var pdno = elem.getAttribute('name');
	         try {
	        	 var index = pdno.indexOf("@");
	        	 if (index > 0) {
					 if (trim(elem.getAttribute('value')).length > 0) {
			        	 var price = pdno.substring(index + 1);
			        	 if (price.startsWith("TBD")) return;
				         pdno = pdno.substring(6, index);
						 var qnty = parseFloat(elem.getAttribute('value'));
						 //window.console.log("pdno=" + pdno + ", qnty=" + qnty + ", price=" + price);		
						 orderTotal += qnty * price;				 
						 itemCountTotal += qnty;
				         grossSalesTotal += parseFloat(trim(document.querySelector("#grossSales_" + pdno).innerHTML).replace("$", ""));
					 }
	        	 }
	         } catch (e) { }
		});
		document.querySelector("#span_order_total").innerHTML = orderTotal.toFixed(2);
		document.querySelector("#span_total_items").innerHTML = itemCountTotal.toFixed(2);
		document.querySelector("#span_total_gross_sales").innerHTML = grossSalesTotal.toFixed(2);	
		const srpTotals = document.getElementById('catalogSRPTotals');
		if (srpTotals !== null) srpTotals.className = "catalogSRPTotals"; // un-hide
	},
	searchOnEnterKey: function(event) {
		var code = getEventCode(event);
		if (code == 13) { // Enter
			PProProfile.keywordsearchSubmit();
			return false;
		}
	},
	keywordsearchSubmit: function() {
		// Don't do this search if we're on the public catalog page
		if (document.querySelector(".ppc-page")) 
			return;

		cancelsubmit = false;
		var searchtext = document.getElementById("SearchText").value;
		if (!searchtext) searchtext = document.getElementById("SearchTextMobile").value;
		// Clear these, so they don't interfere with our keyword search
		try { document.UIservletForm["profile_comm_values"].value = ""; } catch(e) { }
		try { document.UIservletForm["profile_brand_values"].value = ""; } catch(e) { }
		try { document.UIservletForm["CLASSSEARCH"].value = "";	} catch(e) { }
		try { document.UIservletForm["COMM"].value = ""; } catch(e) { }
		try { document.UIservletForm["CLASS"].value = ""; } catch(e) { }
		try { document.UIservletForm["BRAND"].vaule = ""; } catch(e) { }
		if (processing == true) {
			PProDialog.alert(pageLoadingMsg);
			return false;
		}
		searchtext = PProUtil.addZerosToProductNum(searchtext);
		if (!PProProfile.preCheckCatalogSearch(searchtext)) return false;
		if (searchtext != "") {
			gaSearchEvent(searchtext);
			document.UIservletForm["DESC"].value = searchtext;
			document.UIservletForm["nextCommand"].value = "productSearchSubmit";
			PProLoading.show()
			document.UIservletForm.submit();
			return true;
		}
		return false;
	},
	preCheckCatalogSearch: function(searchtext, alertoff) {
		// AIM catalog search request at least 3 letters and those first three to not have a space
		var text = searchtext.split(" ");
		if (!text || text.length < 1 || text[0].length < 3) {
			if (alertoff !== true) PProDialog.alert("Please enter at least 3 characters for your search criteria.");
			cancelsubmit = true;
			return false;
		}
		return true;
	},
	openQuickView: function(event, qtyFieldName, url) {
		event.stopPropagation();
	    if (qtyFieldName) {
		    const qty = document.getElementsByName(qtyFieldName);
	   		url += "&QTY=" + (qty !== null && qty.length > 0 ? qty[0].value : "**");
   		}
		PProLoading.show();
		PProFetch(url)
			.finally(() => PProLoading.hide())
			.then((response) => {
				if (!response.ok) return;
				return response.text();
			}).then((html) => {
				PProDialog.showModal(
					"",
					html
				);
			})
		;
	}, 
	reminderItemsDone: function(url) {
		if (processing == true) {
			PProDialog.alert(pageLoadingMsg);
			return;
		}
		PProLoading.show();
		window.location = url;
	}
};

const PProCalendar = {
	initialize: () => {
		let slideCount = $(".slickify.specials-carousel").children().length;
		let size2 = Math.min(slideCount, 2);
		let size3 = Math.min(slideCount, 3);
		let size4 = Math.min(slideCount, 4);
		let size5 = Math.min(slideCount, 5);
		$(".slickify.specials-carousel").slick({
			"slidesToShow":1,
			"slidesToScroll":1,
			"mobileFirst":true,
			"responsive":[{
				"breakpoint":500,
			"settings":{
				"slidesToShow":size2,
				"slidesToScroll":size2
				}
			},
			{
				"breakpoint":675,
			"settings":{
				"slidesToShow":size3,
				"slidesToScroll":size3
				}
			},
			{
				"breakpoint":910,
			"settings":{
				"slidesToShow":size4,
				"slidesToScroll":size4
				}
			},
			{
				"breakpoint":1100,
			"settings":{
				"slidesToShow":size5,
				"slidesToScroll":size5
				}
			}]
		});
	}
};

const PProDldt = {
	initialize: () => {
		if (!PProUtil.CheckJsOnLoad("PProDldt.checkProblems")) return;
		checkProblems();
	}
};

const PProContactUs = {
	initialize: () => {
		if (!PProUtil.CheckJsOnLoad("PProContactUs.googleAnalytics")) return;
		// Google Analytics tracking
		document.UIservletForm.onsubmit = function() {
			try {
				if (typeof window.gtag === "function")	{
					window.gtag('event', 'Communications - Customer Service Contacted', {
						'event_category': 'communications',
						'event_label': 'Submitted Message: Successful'
					});
				}
			} catch (err) {}
			return true;
		};
	}
};

const PriceList = {
	initialize: () => {
		if (!PProUtil.CheckJsOnLoad("PriceList.initialize")) return;
		document.querySelectorAll(".report-download-submit").forEach((elem) => {
			elem.addEventListener("click", PriceList.downloadSubmitted)
		});
		document.querySelectorAll(".report-submit").forEach((elem) => {
			elem.addEventListener("click", PriceList.submitRequest)
		});
	},
	submitRequest: () => {
		if (document.getElementById('RDLOAD') && document.getElementById('RDLOAD').checked) {
			// download requested
			PriceList.downloadSubmitted();
		} else {
			if (trim(document.getElementById('EMAIL').value) == "") {
				alertField(document.getElementById('EMAIL'), "Please enter an email address.");
				return; // email choice selected, but email blank
			}
		}
		document.UIservletForm.submit();
	},
	downloadSubmitted: () => {
		document.querySelector(".report-criteria").classList.add("hidden"); // Hide criteria
		let newContent = "<p>Your request has been submitted.  Please standby...</p>"; 
		document.getElementById('contentdl5').innerHTML = newContent;		
		return true;
	},
};

const ContactMaint = {
	_abortController: new AbortController(),
	initialize: () => {
		if (!PProUtil.CheckJsOnLoad("ContactMaint.initialize")) return;
		$("button#inactivetoggle").on("click", () => {
			$(".customertab.inactive").each(() => {
				$( this ).toggleClass("hidden");
			});
			$("hr.divider.inactive").each(() => {
				$( this ).toggleClass("hidden");
			});
		});

		// Dynamic data loading
		document.querySelectorAll(".customertab").forEach((elem) => {
			if (!elem.classList.contains("hidden")) {
				const rowData = elem.dataset;
				PProAjax.submit(
					`command=ContactHandler.detail&customer=${rowData.cust}&` +
						`cnid=${encodeURIComponent(rowData.contactId)}` +
						`&ROW=${rowData.row}&changeAllowed=${rowData.allowChange}`,
					`customertab_${rowData.row}`
				);
			}
		});
	}
};

export const Checkout = {
	showMinOrderModal: (message, redirect) => {
		PProDialog.showModal(
			"Minimum Order Warning",
			message,
			new DialogButton("Return to Shopping", () => {
				PProLoading.show();
				window.location = redirect;
			}),
			new DialogButton("Continue with Check Out")
		);
	}
}

export const SystemPage = {
	initialize: () => {
		// Show the search bar only when on the profile page
		if (document.getElementById("advanced__search")) {
			document.querySelectorAll(".header__search").forEach(elem => elem.style.display = "block");

			document.getElementById("SearchText").addEventListener("keydown", function(event) {
				Ecom2.PProProfile.searchOnEnterKey(event);
			});

			document.getElementById("products-dropdown").classList.add("pdcs");
		} else if (document.querySelector(".ppc-page")) {
			document.querySelectorAll(".header__search").forEach(elem => elem.style.display = "block");
			
			function publicSearchSubmit() {
				const searchTerm = document.getElementById("SearchText").value;
				if (searchTerm.trim().length >= 3) {
					PProLoading.show();
					Ecom2.gaSearchEvent(searchTerm, true);
					window.location.href="command=PublicCatalogInfoHandler.productsearch&keyword=" + encodeURIComponent(searchTerm) + "&TITLE="+ encodeURIComponent("Results for '" + searchTerm + "'");
				} else {
					Ecom2.PProDialog.alert("Search terms must have at least three characters.");
				}
			}

			document.getElementById("SearchText").addEventListener("keydown", function(event) {
				if (event.key === 'Enter') {
					publicSearchSubmit();
				}
			});

			document.getElementById("SearchTextSubmit").addEventListener("click", function(event) {
				publicSearchSubmit();
			});
		}
		
		// Populate menus, shopping cart quantity and amount display if present
		if (document.getElementById("skipajax") == null) {
			SystemPage.populateCartItems().then((data) => {}).catch((error) => {});
			SystemPage.populatePublicCatalogMenus();
		}

		if (document.querySelector(".ppro-login-waiting")) {
			PProLoading.show();
		}
	
		// Automatically show loading div any time a form is submitted
	    var form = document.getElementById("UIservletForm");
	    if (form !== null) form.addEventListener("submit", function (event) {
	    	PProLoading.show();
	    });

		// ECOM1 customOnLoad logic
		processing = false;
		if (!kerchunkEnabled) placeFocus();
		// Show timeout information
	    let f_signoff = () => {
	    	PProLoading.show();
			SystemPage.doLogout();
	    };
		var sTimeout = document.getElementById('session_timeout_value');
		if (sTimeout) {
			document.getElementById('session_time_left').innerHTML = (sTimeout.value / 60);
			SystemPage.session_timer(
				sTimeout.value * 1000, // milliseconds
				(timeleft) => { // called every step to update the invisible count down
					document.getElementById('session_time_left').innerHTML = timeleft;
				},
				() => { // what to do after
					PProDialog.modalOnClose(f_signoff);
					PProDialog.showModal(
						"Message",
						"Your session has expired. Please log in again.",
						new DialogButton("OK", f_signoff)
					);
				}
			);
		}
		PProLoading.hideSearchSkeleton();
		if (!navigator.cookieEnabled) {
			PProDialog.modalOnClose(f_signoff);
			PProDialog.showModal(
				"Message",
				"Please enable cookies to properly use this site.",
				new DialogButton("OK", f_signoff)
			);
		}
		document.querySelectorAll(".order-button").forEach((elem) => {
			elem.addEventListener("click", () => {
				PProLoading.show();
				window.location="command=catalogpage&name=profile&parm=nothing";
			});
		});
		document.querySelectorAll(".calendar-button").forEach((elem) => {
			elem.addEventListener("click", () => {
				PProLoading.show();
				window.location="command=calendar.create";
			});
		});
		document.querySelectorAll(".cart-button").forEach((elem) => {
			elem.addEventListener("click", () => {
				PProLoading.show();
				if (document.UIservletForm) {
					var reminderFlag = document.UIservletForm["REMINDER"];
					var command = document.UIservletForm["command"];
					if (reminderFlag && command && command.value == "orderq") {
						var nextCommand = document.UIservletForm["nextCommand"];
						if (nextCommand) nextCommand.value = "";
						document.UIservletForm.submit();
						return;
					}
				}
				window.location="command=cart";
			});
		});
		document.querySelectorAll(".empty-cart-button").forEach((elem) => {
			elem.addEventListener("click", () => {
				return cancelPrompt();
			});
		});
		document.querySelectorAll(".nav-search-submit").forEach((elem) => {
			elem.addEventListener("click", PProProfile.keywordsearchSubmit);
		});
		document.querySelectorAll(".keyword-search-field").forEach((elem) => {
			elem.addEventListener("keydown", PProProfile.searchOnEnterKey);
		});
	},
	customOrderEntryOnLoad: () => {
		if (!PProUtil.CheckJsOnLoad("SystemPage.customOrderEntryOnLoad")) return;
		arrOldValues = ""; // for orderqajax requests
		window.addEventListener("DOMContentLoaded", () => {
			profileCatalogPageTooltipSetup();
			// Enable toggle local items button after page finishes loading
			var toggleButton = document.getElementById("toggleButton");
			if (toggleButton != null) toggleButton.disabled = false;
		});
		PProProfile.calculateGrossSalesTotals();
	},
	populateCartItems: () => {
		// Check if page contains shopping cart info
		if (!document.querySelectorAll("#cartitemcount, #cartitemcount_mobile, .cartitemcount").length) {
			return Promise.reject();
		}
		const fetchPromise = PProFetch("command=cartitemsajax", {
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			credentials: "include"
		});	
		const jsonResponse = fetchPromise.then((response) => {
			if (!response.ok) throw new Error();
			return response.json();
		});
		jsonResponse.then((data) => {
			SystemPage.updateCartItemsElements(data);
			const ch = document.querySelector(".cart-hide");
			if (ch) {
				ch.hidden = data.ident !== "";
			}
		});

		return jsonResponse;
	},
	updateCartItemsElements: (data) => {
		if (data.dldt && data.dldt == "disable") {
			// Customer hasn't started an order yet.  Direct them to first step.
			var d1 = document.getElementById("cartdisable");
			if (d1) {
				d1.setAttribute("href", "command=catalogpage&name=profile&parm=nothing");
			}
		}
		if (Number(data.items) > 0) {
			document.querySelector("#cartitemcount").innerHTML = data.items;
			document.querySelector(".cart-info").setAttribute("data-items", data.items);
			document.querySelector("#cartitemamount").innerHTML = "$" + data.amount;
		} else {
			document.querySelector("#cartitemcount").innerHTML = 0;
			document.querySelector(".cart-info").setAttribute("data-items", "");
			document.querySelector("#cartitemamount").innerHTML = "$0.00"
		}
		const cd = document.querySelector("#cartdate");
		if (cd) {
			if (data.dldt !== "disable") {
				document.querySelector("#cartdate").innerHTML = data.dldt.slice(4, 6) + "/" + data.dldt.slice(6, 8) + "/" + data.dldt.slice(2, 4);
			} else {
				document.querySelector("#cartdate").innerHTML = "";
			}
		}
		document.querySelector("#cartcutoff").innerHTML = data.cutoff;
	},

	// Check if the product dropdown is currently being displayed
	publicCatalogDisplayed: () => {
		const prodDropdown = document.getElementById("products-dropdown");
		if (!prodDropdown || getComputedStyle(prodDropdown).display === "none") {
			return false;
		}
		return true;
	},

	updateMenus: (data) => {
		if (data.groups) {
			for (let i = 0; i < data.groups.length; i++) {
				let element = data.groups[i];
				let SubMenuWrap = document.createElement("li");
				SubMenuWrap.className = "mb-2";

				let SubMenuTitle = document.createElement("a");
				SubMenuTitle.className="d-block pb-1";
				SubMenuTitle.innerText = element.desc;
				SubMenuWrap.appendChild(SubMenuTitle);

				document.getElementById("products-dropdown-content").appendChild(SubMenuWrap);
				
				// Check if PDCS is set by checking the display of a .PDCS element
				const PDCSCheck = document.createElement("span");
				PDCSCheck.hidden = true;
				PDCSCheck.classList.add("pdcs");
				SubMenuWrap.appendChild(PDCSCheck);
				
				const PDCS = getComputedStyle(PDCSCheck).display === "block";
				SubMenuWrap.removeChild(PDCSCheck);

				if (!PDCS){
					SubMenuTitle.addEventListener("click", function(){
						PProLoading.show();
						gaMenuSearchEvent(element.desc);
					});
					SubMenuTitle.href = element.url;
				} else {
					SubMenuTitle.href = "javascript:void(0)";

					// Build values to post when clicked
					let postItems = "";
					if (element.queryParms) {
						for(const key in element.queryParms) {
							postItems += "<input type='hidden' name='" + key + "' value='" + element.queryParms[key] +  "'>";
						}
						postItems += "<input type='hidden' name='parm' value='nothing'><input type='hidden' name='nextCommand' value='productsearchsubmit'>";
					}

					SubMenuTitle.addEventListener("click", function() {
						PProLoading.show();
						gaMenuSearchEvent(element.desc);
						PProPost('orderq', postItems);
					});
				}
				document.getElementById("mobile-products-dropdown-content").appendChild(SubMenuWrap.cloneNode(true));
			}
			// Unhide products dropdown
			if (data.groups.length > 0) {
				document.getElementById("products-dropdown").classList.remove("hidden");
				document.getElementById("products-dropdown-mobile").classList.remove("hidden");
			}
		}
	},
	populatePublicCatalogMenus: () => {
		if (!SystemPage.publicCatalogDisplayed())
			return;

		const cached = localStorage.getItem("ecom_publicCatalog.categories");
		let cacheJson;
		if (cached) {
			cacheJson = JSON.parse(cached);
		}
		const dayInMs = 1000 * 60 * 60 * 24;
		// If the cached data isn't expired
		if (cacheJson?.date && cacheJson.date + dayInMs > Date.now()) {
			SystemPage.updateMenus(cacheJson);
		} else {
			// populatePublicCatalogMenus Callback for populating category menus for public product catalog pages
			const fetchPromise = PProFetch("command=PublicCatalogInfoHandler.options&AJAX=Y", {
				headers: {
					"Content-Type": "application/json",
				},
				cache: "no-cache",
				credentials: "include"
			});
			const jsonResponse = fetchPromise.then((response) => {
				if (!response.ok) throw new Error();
				return response.json();
			});
			jsonResponse.then((data) => {
				data.date = Date.now();
				localStorage.setItem("ecom_publicCatalog.categories", JSON.stringify(data));
				SystemPage.updateMenus(data);
			});
		}
	},

	session_timer: (time,update, complete) => {
		var start = new Date().getTime();
		var interval = setInterval(function() {
			var now = time - (new Date().getTime() - start);
			if (now < -30000) {
				clearInterval(interval);
				complete();
			}
			else update(1 + Math.floor(now / (60 * 1000)));
		}, 1000); // the smaller this number, the more accurate the timer will be
	},
	doLogout: (bForce) => {
		//replace the current page in history with the sign out page
		history.replaceState(null,'',window.location.origin + window.location.pathname + "?command=iosignoff");

		PProPost("iosignoff", bForce ? '<input type="hidden" name="force" value="Y">' : '');
	}
};
